// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-11T19:09:14.038Z
// Property: Aster (ID: 6767906449167730)
// Collections: 58 amenities, 10 floorplans (live), 52 photos, 76 POIs, 3 reviews, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5760613594693632",
  "multihub_property_id": "6767906449167730",
  "property_external_id": "s14stb7",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/cavalli-at-iron-horse-station-north-richland-hills-tx/s14stb7/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "aster",
  "property_name": "Aster",
  "property_website_url": "https://demo-aster.multiscreensite.com/",
  "property_domain": null,
  "property_address": "100 Iron Horse Blvd",
  "property_full_address": "100 Iron Horse Blvd, North Richland Hills, TX 76180",
  "property_address_1": "100 Iron Horse Blvd",
  "property_address_2": null,
  "property_address_city": "North Richland Hills",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "76180",
  "property_address_country": "US",
  "property_address_county": "Tarrant County",
  "property_neighborhood_address": "Iron Horse",
  "property_address_latitude": "32.8459713",
  "property_address_longitude": "-97.24484939999999",
  "property_email": null,
  "property_phone": "1234567890",
  "property_call_tracking_phone": null,
  "property_company_name": "Rebel Residential",
  "property_company_url": null,
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Connected North Richland Hills living starts at Aster.</strong> Explore studio to three-bedroom floor plans with stainless steel appliances, luxury wood plank flooring, tall ceilings, and easy access to everyday convenience—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_long_description": "<p><strong>Connected North Richland Hills living starts here.</strong> At Aster, you’re positioned near Iron Horse Station, where TEXRail puts Fort Worth, Grapevine, DFW Airport, and broader Metroplex connections within easy reach. Around you, City Point is bringing a walkable mix of dining, retail, green space, and everyday convenience to the former North Hills Mall area, while NRH parks and the Cotton Belt Trail add room to get outside.</p><p>Choose from <a href=\"/floor-plans\">studio, one-, two-, and three-bedroom floor plans</a> with modern finishes that feel polished from day one: <strong>stainless steel appliances, luxury wood plank flooring, tall ceilings</strong>, and light-filled layouts made for everyday ease. Beyond your front door, <a href=\"/amenities\">community amenities</a> such as a resort-style pool with cabanas and BBQ spaces, fitness and yoga studios, game room, resident lounge, package lockers, EV charging, and covered parking bring extra convenience to your routine. It’s a fresh, well-connected home base in one of North Richland Hills’ most dynamic corridors.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1d-8f2e-70b9-8b96-d3aabcea9ac3.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of a modern apartment building with stone and beige facade and dark accents, under a cloudy blue sky.",
    "public_id": "01a03a1d-8f2e-70b9-8b96-d3aabcea9ac3",
    "storage_key": "property/6767906449167730/01a03a1d-8f2e-70b9-8b96-d3aabcea9ac3.webp",
    "width": 2863,
    "height": 1909
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "328",
  "property_year_built": "2021",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.8170731707317",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": null,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": "null",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-dc53-717d-bf87-35c73d2c4b9a.webp",
  "property_primary_logo_media": {
    "alt_text": "The property name 'ASTER' in white sans-serif font on a black background.",
    "public_id": "01a03a1c-dc53-717d-bf87-35c73d2c4b9a",
    "storage_key": "property/6767906449167730/01a03a1c-dc53-717d-bf87-35c73d2c4b9a.webp",
    "width": 863,
    "height": 212
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-dcc1-76a8-83b5-0e1e5e922e9f.webp",
  "property_secondary_logo_media": {
    "alt_text": "ASTER logo",
    "public_id": "01a03a1c-dcc1-76a8-83b5-0e1e5e922e9f",
    "storage_key": "property/6767906449167730/01a03a1c-dcc1-76a8-83b5-0e1e5e922e9f.webp",
    "width": 863,
    "height": 212
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-dc53-717d-bf87-35c73d2c4b9a.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The property name 'ASTER' in white sans-serif font on a black background.",
    "public_id": "01a03a1c-dc53-717d-bf87-35c73d2c4b9a",
    "storage_key": "property/6767906449167730/01a03a1c-dc53-717d-bf87-35c73d2c4b9a.webp",
    "width": 863,
    "height": 212
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1d-10a3-77ed-88e8-233298f58a18.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a03a1d-10a3-77ed-88e8-233298f58a18",
    "storage_key": "property/6767906449167730/01a03a1d-10a3-77ed-88e8-233298f58a18.webp",
    "width": 863,
    "height": 212
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5760613594693632/01a03915-19b6-71d4-aeb8-805d7480607e.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#313a44",
  "property_secondary_color": "#be7d3d",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 3",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "605 - 9,801,085 sq ft",
  "property_sqft_min": "605",
  "property_sqft_max": "9,801,085",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 17,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ_e0KvWV5ToYRN8b7ZJCmVzA",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Aster",
  "property_home_romance_title": "Experience the Joy of Living at Our Vibrant Community",
  "property_home_amenities_blurb": "<p><strong>Amenities made for momentum.</strong> At Aster, resort-style pool days, cabana lounging, BBQ areas, fitness and yoga spaces, and game-ready lounges bring more ease to every routine.</p><p>Inside, stainless steel appliances, luxury wood plank flooring, and tall ceilings create a polished backdrop across studio, one-, two-, and three-bedroom layouts—plus everyday perks like package lockers, EV charging, covered parking, and pet-friendly conveniences.</p>",
  "property_home_floorplans_blurb": "<p><strong>Choose your space, then make it your own.</strong> Aster offers studio, one-, two-, and three-bedroom apartments in North Richland Hills with open layouts, tall ceilings, luxury wood plank flooring, and stainless steel appliances. Compare current availability, pricing, and plan styles, then look for everyday perks like open kitchens, comfortable living areas, and select homes with outdoor space.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at Aster.</strong> Preview kitchens with sleek cabinetry, stainless steel appliances, and statement islands, plus wood plank flooring, tall ceilings, and bright, open interiors. The gallery also captures polished lounge and game spaces, along with the pool deck and cabanas that bring the community into focus.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Iron Horse puts the map to work.</strong> From Aster, TEXRail is nearby for car-light Metroplex trips, Babe’s Chicken Dinner House and Ernie’s Seafood are easy local stops, and the Cotton Belt Trail is ready for fresh-air time. Loop 820 keeps North East Mall, NRH2O, NYTEX Sports Centre, and the wider Mid-Cities within reach—then relaxed outdoor spaces bring it all back home.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents notice the care at Aster.</strong> Reviews highlight a leasing experience that feels clear, supportive, and easy from tour to move-in, with frequent shoutouts for Alecka, Brandi, and the on-site team. Visitors also point to clean community spaces, impressive amenities, and thoughtful answers that make every step feel more personal.</p>",
  "property_neighborhood_blurb": "<p><strong>Let the map do more than point the way.</strong> From Aster, Iron Horse reads like a practical North Richland Hills itinerary: hop on TEXRail at the nearby station for car-light trips across the Metroplex, grab comfort food at Babe’s Chicken Dinner House, keep Ernie’s Seafood in your back pocket for dinner, or spend a sunny stretch along the Cotton Belt Trail. When plans call for more, Loop 820 puts North East Mall, NRH2O, NYTEX Sports Centre, and the wider Mid-Cities within easy reach. Back home, <a href=\"/amenities\">pet-friendly amenities</a> and relaxed outdoor spaces make the neighborhood feel even easier to enjoy. Use the map below to trace your favorites, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Aster fits into the Iron Horse rhythm.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that keep pace with your day.</strong> At Aster, comfort starts with spaces that are easy to use and enjoyable to come home to—from a resort-style pool with cabanas and BBQ areas to fitness, yoga, lounge, and game spaces that give your routine more room to flex.</p><p>Inside your apartment, <strong>stainless steel appliances, luxury wood plank flooring, and tall ceilings</strong> create a clean, modern backdrop across studio, one-, two-, and three-bedroom layouts. Everyday details add even more ease, including package lockers, EV charging, covered parking, and pet-friendly conveniences. Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Aster’s amenities come together in North Richland Hills.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Aster.</strong> Choose a polished studio, one-, two-, or three-bedroom apartment with stainless steel appliances, luxury wood plank flooring, tall ceilings, and light-filled layouts. With everyday conveniences beyond your door and connected North Richland Hills living all around, your next home base is ready when you are.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> The Aster leasing team is here to help you connect with our North Richland Hills apartments, from modern floor plans to everyday conveniences. Reach out today, and let us point you in the right direction.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Aster?</strong> Start here for quick answers on the community, leasing, floor plans, finishes, and connected North Richland Hills living. If you don’t see what you need, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your rhythm.</strong> Aster’s floor plan collection ranges from efficient studios to expansive three-bedroom apartments, giving you options whether you want a streamlined home base, a separate bedroom retreat, or extra space for a dining setup, desk, or guests. Each layout is designed to feel open and polished, with tall ceilings, luxury wood plank flooring, and stainless steel appliances adding a clean, modern finish from the start.</p><p>Browse current availability to compare bedroom count, pricing, and floor plan style side by side, then look for the details that make daily routines easier—open kitchens, comfortable living areas, and select homes with outdoor space. When you’re ready to narrow it down, explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite Aster apartment in North Richland Hills up close.</p>",
  "property_gallery_blurb": "<p><strong>See Aster from the inside out.</strong> Browse the gallery for the details that make the design click: a kitchen island framed by sleek cabinetry and stainless steel, light moving across wood plank flooring, and tall ceilings that give each room an open, finished feel. Photos also take you beyond the apartment, from the <a href=\"/amenities\">pool deck with cabanas</a> to lounge and game spaces with a polished, comfortable look.</p><p>As you scroll, picture how studio, one-, two-, and three-bedroom interiors could come together with your furniture, routines, and favorite quiet corners. Then keep exploring with <a href=\"/virtual-tours\">virtual tours</a> or schedule a visit to experience Aster in North Richland Hills in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Aster from every angle.</strong> Use the interactive map to browse available apartments, see how the community connects to nearby transit, dining, retail, green space, and trail access, and get a clearer feel for this well-connected North Richland Hills location.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, patios, and daily walks.</strong> At Aster, pet-friendly living feels built into the routine—not tacked on. Let your dog stretch out at the on-site Bark Park, take advantage of pet care conveniences, and choose select homes with private fenced yards when extra outdoor space is high on your wish list. Private patios or balconies also make it easy to add a sunny perch, a water bowl, or a quiet moment outside.</p><p>When you want a bigger change of scenery, Tipps Canine Hollow Dog Park adds off-leash space nearby in North Richland Hills. Review the policy details on this page for current fees and restrictions, then explore Aster’s <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the spaces that make life with pets feel easier.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at Aster?</strong> Share the connected North Richland Hills location, polished <a href=\"/floor-plans\">floor plans</a>, modern finishes, and everyday conveniences that make your home base stand out. Invite a friend to discover Aster and join you here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Aster.</strong><br>Manage everyday details from your well-connected North Richland Hills home base. Log in to pay rent, submit maintenance requests, and keep your account current—so your routine stays as polished and convenient as life at Aster.</p>",
  "property_reviews_blurb": "<p><strong>See what stands out at Aster.</strong> Residents and visitors consistently point to a smooth, supportive leasing experience, with shoutouts for team members like Alecka and Brandi who are described as “kind, patient, and helpful.” Reviewers mention clear communication, thoughtful answers, and a process that feels easier from first tour to move-in.</p><p>You’ll also see praise for the clean, presentable community, impressive amenities, and a welcoming on-site team that makes tours feel personal. From the first look around to settling into a new home, these reviews offer a real sense of the service and care people notice at Aster in North Richland Hills.</p>",
  "property_created_at": "1787681334634",
  "property_scheduletour_blurb": "<p><strong>See connected living up close.</strong> Tour Aster and picture polished finishes, light-filled layouts, and everyday conveniences coming together in a fresh North Richland Hills home base. From studio to three-bedroom options, there’s more to experience in person—schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>The Aster leasing team will be in touch soon. In the meantime, picture connected North Richland Hills living with polished floor plans, modern finishes, light-filled layouts, and everyday convenience just beyond your door.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk the space before you plan the visit.</strong> Aster’s virtual tours let you move room by room through the layouts and amenity spaces that matter most, right from wherever you are. Explore the A4 floor plan, step into the two-bedroom B1 tour, or preview the one-bedroom apartment tour to see open living areas, tall ceilings, wood-style flooring, granite surfaces, modern cabinetry, stainless steel appliances, and the way natural light shapes each room. Then shift into community mode with tours of the leasing center and convenience store, Resident Lounge with WiFi, strength and cardio studio, media center, and yoga room, plus the Apartments.com community video for a broader look. When a space catches your eye, compare <a href=\"/floor-plans\">available floor plans</a>, browse more <a href=\"/amenities\">amenity details</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> in North Richland Hills.</p>",
  "property_copyright": "2026 All Rights Reserved. Aster",
  "property_seo_title_home": "Aster |  Apartments in North Richland Hills, TX",
  "property_seo_description_home": "Elevate your lifestyle at Aster in North Richland Hills, TX! Enjoy modern floor plans, luxury finishes, and spacious living. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | North Richland Hills, TX Apartments for Rent",
  "property_seo_description_floorplans": "Find your perfect fit at Aster in North Richland Hills, TX! Choose from stunning studio to spacious three-bedroom layouts. Your new home awaits!",
  "property_seo_title_amenities": "Amenities | North Richland Hills, TX Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Aster in North Richland Hills, TX, with stainless steel appliances, tall ceilings, and luxury wood plank flooring! ",
  "property_seo_title_gallery": "Gallery | Apartments in North Richland Hills, TX",
  "property_seo_description_gallery": "Capture the essence of luxury living at Aster in North Richland Hills. With stunning photos, imagine your future in spacious studios to three-bedroom homes!",
  "property_seo_title_virtualtours": "Virtual Tours | Aster Apartments",
  "property_seo_description_virtualtours": "Experience Aster in North Richland Hills, TX! Take a virtual tour of our charming studios to spacious three-bedroom apartments. Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Aster Apartments",
  "property_seo_description_interactivemap": "Find your perfect haven at Aster in North Richland Hills, TX! Use our interactive map to explore gorgeous floor plans and luxury amenities today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in North Richland Hills, TX",
  "property_seo_description_neighborhood": "Uncover the charm of North Richland Hills at Aster. From parks to dining, see what's around our vibrant community and embrace the local favorites.",
  "property_seo_title_contact": "Contact Us | Aster",
  "property_seo_description_contact": "Reach out to Aster in North Richland Hills, TX! Whether you need a studio or three-bedroom, our leasing team is ready to assist. Get your questions answered!",
  "property_seo_title_faqs": "FAQs | Apartments in North Richland Hills, TX",
  "property_seo_description_faqs": "Find answers to your questions about Aster in North Richland Hills, TX. From floor plans to luxury amenities, get the insights you need today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in North Richland Hills, TX",
  "property_seo_description_reviews": "Join the Aster community in North Richland Hills, TX! Experience luxury living with modern amenities and hear what our residents love most!",
  "property_seo_title_applynow": "Apply Now | Apartments in North Richland Hills, TX",
  "property_seo_description_applynow": "Experience luxury living at Aster in North Richland Hills, TX. With modern floor plans and upscale amenities, your perfect home awaits! Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Aster",
  "property_seo_description_residentaccess": "Unlock the Aster resident portal for easy rent payments, maintenance requests, and community updates—all at your fingertips in North Richland Hills, TX!",
  "property_seo_title_referafriend": "Refer A Friend | Aster",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Aster in North Richland Hills, TX, and enjoy exclusive rewards. Join our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Aster",
  "property_seo_description_scheduletour": "Discover Aster in North Richland Hills, TX! Schedule your tour today and explore modern comforts in a vibrant community.",
  "property_seo_title_privacy": "Privacy Policy | Aster",
  "property_seo_description_privacy": "At Aster in North Richland Hills, your privacy matters. Uncover how we protect your data while you enjoy a vibrant community. View our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Aster",
  "property_seo_description_accessibility": "Experience seamless living at Aster in North Richland Hills, TX. Our commitment to digital inclusion ensures everyone can connect with our vibrant community.",
  "property_seo_title_sitemap": "Sitemap | Aster",
  "property_seo_description_sitemap": "Uncover the charm of Aster in North Richland Hills, TX—your guide to our vibrant community awaits. Check out our sitemap for easy navigation!",
  "property_seo_title_thankyou": "Thank You | Aster",
  "property_seo_description_thankyou": "Thank you for reaching out to Aster in North Richland Hills! A team member will connect with you soon to help you find your perfect home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in North Richland Hills, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1789049333137",
  "amenities": [
    {
      "id": "ec_a675e42f56137d3d79d41798",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2bafde532cd71424b7cf794c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Package Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_336a18b28423ee84de4a500e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Play Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77960cbab7e1d43c6209a084",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Pet Care",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0aaf904ef95e8eab70ec14b0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3eb963b30d4a663ce3b255d3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_45456729b45880f63d45c286",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6cf6854f092d6a2943744995",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3520266a8e9efa587d473854",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5cce4343adb91b93f548fc74",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bfd7306c10d72356a95e604f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9105245bdd759563ea20673a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Gameroom",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4322756df97532c546338de5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Bicycle Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09896b38a4a9dc5c0aac31b0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "**Coming Soon",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8f76d186cc0b1364fd12aace",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "*In Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e72774d39a6672a1ac656526",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "9 Ceilings w/ Custom Light Fixtures*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a688c0dae179c7f922db07dd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "ADA",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e43c30ec4b30bb5ebf65d961",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "American Landmark 360 Resident Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3748f029c4aaacc0a6573d90",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Bark Park for your Furry Friends",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_901d4a0ee9133fe000a77e72",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Community Convenience Store**",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78b243ba1c73d45e7da79210",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled Access Gates",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_493158f050eaf7420d91878e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Convenient 24/7 Online Resident Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da5c0847a9c241bd2f51ca27",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Covered Parking Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2bb432d200a86387954d40cf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Designer Cabinetry & Backsplash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b54e6575eda79c681d973c33",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Electric Car Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0388dd3fcd4bbe7047ab807f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Exterior French Doors*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f62ac14bdab72e7cd44c560",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Full-size washer/dryer",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b61ae383e9b97e5b5cd9f175",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Garden Tubs or Walk-In Showers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9cee1e7d7b8671ccd74a102",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "In-Home Washer and Dryers*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f20ba3ec216b6e2f3228057d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Modern Strength Training & Cardio Studio",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f1cbd43799d36f66368c5b0f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Onsite Storage Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f6ef12bb2ba1fcf4fce4b6de",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Parcel Pending Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d1bab0863f190d02d6afc4dc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Private Fenced Yards*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_872759d19658c1d7d944c34e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Private Patios or Balconies",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1716a6fbb111a0f753c755d2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Resident Gameroom w/ Foosball",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7832068e7fb4ed9ffb9f5ded",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Resident Lounge w/ WiFi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a135d506208ec53c5fc0eb8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Resident Picnic & BBQ Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6c0333c3d49c8947490c67a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Kitchen Appliances",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_859c191cfc1ba113ee818fc5",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Upgraded",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b428e4e79c0a4daeb0442ae",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "USB Outlets*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3b74ac75346c34583405290",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Vinyl-Wood Plank Flooring",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f0f577b37280e39a5297cef1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a23deb0cda83929fa3fc110f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3d1d4b1ebbb48a3a93c4e3a7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee945f08da111cab3a73dd52",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e3f714ccb1f832c29756f87",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab8f17f9c370fb12b6ea098d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56faf655075c0753d0dce101",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df2374bc26b5f0690f5ef30f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16c9e3053f2797786bd078d8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cef0636df5f85419eece740e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_696df2bd73b0193ca484e724",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f1ac0b96016e3d9fc70c274c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_81294f328e314d42bf4eaa3e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_070f9b09921d9b28deecced2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Vaulted Ceiling",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9bc0a0b0356b70de3fe07331",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Vinyl Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e681d3c937f5c3f60a8069b4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Yard",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f675ab7c2fdb728306651dd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "apartments",
      "external_id": "false",
      "title": "Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_fad59dd9-c71b-4dc5-b14d-3af32727c436",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-a3b5-721a-befe-ee4c1c7611ae.webp",
      "image_media": {
        "alt_text": "View from a balcony overlooking a resort-style swimming pool and apartment buildings.",
        "public_id": "01a03a20-a3b5-721a-befe-ee4c1c7611ae",
        "storage_key": "property/6767906449167730/01a03a20-a3b5-721a-befe-ee4c1c7611ae.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool and outdoor amenities from your private balcony, with views of the surrounding apartment buildings.",
      "link": "",
      "alt_text": "View from a balcony overlooking a resort-style swimming pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7e1be2b9-7057-4d07-bbbc-ab7471b764f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-916b-75ce-b00f-20dc492207d5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and island.",
        "public_id": "01a03a20-916b-75ce-b00f-20dc492207d5",
        "storage_key": "property/6767906449167730/01a03a20-916b-75ce-b00f-20dc492207d5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring granite countertops, stainless steel appliances, and a large island perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_387a0cf6-6d8e-47a6-8ce7-b597abf819e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-8b80-70c8-8148-f694c2ecab0c.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills, seating, and string lights.",
        "public_id": "01a03a20-8b80-70c8-8148-f694c2ecab0c",
        "storage_key": "property/6767906449167730/01a03a20-8b80-70c8-8148-f694c2ecab0c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining with our community's grilling station, complete with spacious seating and ambient string lights for evening gatherings.",
      "link": "",
      "alt_text": "Outdoor grilling area with two built-in grills, seating, and string lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f687a15c-f685-4385-85ba-84ab522282dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-8b84-7625-9b78-abc214d02943.webp",
      "image_media": {
        "alt_text": "Outdoor dog park with a play structure and waste station.",
        "public_id": "01a03a20-8b84-7625-9b78-abc214d02943",
        "storage_key": "property/6767906449167730/01a03a20-8b84-7625-9b78-abc214d02943.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy our community's dedicated dog park, perfect for your furry friends to play and socialize in a safe and fun environment.",
      "link": "",
      "alt_text": "Outdoor dog park with a play structure and waste station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2529a02b-0360-49db-9d1f-29a3110e1dee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-88cb-760e-90d7-a12c26011985.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and a seating area.",
        "public_id": "01a03a20-88cb-760e-90d7-a12c26011985",
        "storage_key": "property/6767906449167730/01a03a20-88cb-760e-90d7-a12c26011985.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool, perfect for relaxing and soaking up the sun. Featuring ample lounge chairs and a comfortable outdoor seating area.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and a seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7cc3b17a-8370-40ac-a6f2-85fc776f05ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-812c-77bb-83a5-9a9a801bc5df.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and waterfall feature at apartment complex.",
        "public_id": "01a03a20-812c-77bb-83a5-9a9a801bc5df",
        "storage_key": "property/6767906449167730/01a03a20-812c-77bb-83a5-9a9a801bc5df.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning resort-style swimming pool, surrounded by comfortable lounge chairs and accented by a beautiful waterfall feature. Perfect for relaxation and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and waterfall feature at apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_adf2c565-c253-4571-805f-084a3e335764",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-7315-726f-940b-85ff20b072e6.webp",
      "image_media": {
        "alt_text": "Convenience store with snacks and refrigerators.",
        "public_id": "01a03a20-7315-726f-940b-85ff20b072e6",
        "storage_key": "property/6767906449167730/01a03a20-7315-726f-940b-85ff20b072e6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stock up on snacks and essentials at our on-site convenience store, featuring a wide selection of treats and refrigerated items.",
      "link": "",
      "alt_text": "Convenience store with snacks and refrigerators.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a6e0e3bd-04c7-49a3-8448-1dcd80c9a70c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-703e-75af-8b0e-09b64a676180.webp",
      "image_media": {
        "alt_text": "Metal horse sculpture in a circular garden bed at the entrance of an apartment complex.",
        "public_id": "01a03a20-703e-75af-8b0e-09b64a676180",
        "storage_key": "property/6767906449167730/01a03a20-703e-75af-8b0e-09b64a676180.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Beautiful metal horse sculpture art installation at the entrance of the community, adding a unique artistic flair to the property's exterior.",
      "link": "",
      "alt_text": "Metal horse sculpture in a circular garden bed at the entrance of an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0a03e1de-739b-4c22-b014-2f15a4204744",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-5809-75de-aa8d-b1744647ef7d.webp",
      "image_media": {
        "alt_text": "Cavalli at Iron Horse Station monument sign and exterior building view.",
        "public_id": "01a03a20-5809-75de-aa8d-b1744647ef7d",
        "storage_key": "property/6767906449167730/01a03a20-5809-75de-aa8d-b1744647ef7d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "The Cavalli at Iron Horse Station apartment complex exterior featuring a large monument sign with the property name and address.",
      "link": "",
      "alt_text": "Cavalli at Iron Horse Station monument sign and exterior building view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_608f8a38-70cb-4dff-87fe-4a4c5a13332d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-554d-70af-8bb0-9779fc5c6c44.webp",
      "image_media": {
        "alt_text": "Apartment building with garages and parking lot.",
        "public_id": "01a03a20-554d-70af-8bb0-9779fc5c6c44",
        "storage_key": "property/6767906449167730/01a03a20-554d-70af-8bb0-9779fc5c6c44.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Exterior view of an apartment building featuring attached garages and a paved parking area under a clear blue sky.",
      "link": "",
      "alt_text": "Apartment building with garages and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_be00d503-7b41-4034-a816-4b09adb967b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-5370-739b-b791-06dfb86e9bee.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a circular drive and horse sculptures in the center.",
        "public_id": "01a03a20-5370-739b-b791-06dfb86e9bee",
        "storage_key": "property/6767906449167730/01a03a20-5370-739b-b791-06dfb86e9bee.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Exterior view of the apartment complex featuring modern architecture and decorative horse sculptures at the entrance.",
      "link": "",
      "alt_text": "Apartment building exterior with a circular drive and horse sculptures in the center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d58fdcf4-9090-4fae-9251-e8e58c0f0c35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-4f4c-728d-816c-b1305326e5a6.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and a paved parking lot.",
        "public_id": "01a03a20-4f4c-728d-816c-b1305326e5a6",
        "storage_key": "property/6767906449167730/01a03a20-4f4c-728d-816c-b1305326e5a6.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "The exterior of a beautiful, modern apartment complex featuring a stucco and stone facade, balconies, and ample parking. Ideal for upscale living.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with balconies and a paved parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8935916e-a69d-451e-9554-488a58123289",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-3f69-7048-b270-911ae3eb2ba9.webp",
      "image_media": {
        "alt_text": "Lush green sofas and plush brown tufted sofas arranged around a wicker coffee table in a stylish lounge area with built-in shelving and modern light fixtures.",
        "public_id": "01a03a20-3f69-7048-b270-911ae3eb2ba9",
        "storage_key": "property/6767906449167730/01a03a20-3f69-7048-b270-911ae3eb2ba9.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and socialize in our inviting community lounge, featuring comfortable seating, stylish decor, and ample space for residents to connect and unwind.",
      "link": "",
      "alt_text": "Lush green sofas and plush brown tufted sofas arranged around a wicker coffee table in a stylish lounge area with built-in shelving and modern light fixtures.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_187bb241-99e1-462e-917c-7d46a61f3e6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-35af-7719-b693-5cef7331e505.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool with lounge chairs and buildings in the background.",
        "public_id": "01a03a20-35af-7719-b693-5cef7331e505",
        "storage_key": "property/6767906449167730/01a03a20-35af-7719-b693-5cef7331e505.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and modern apartment buildings. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Apartment complex swimming pool with lounge chairs and buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ac8c8b27-7b1f-4676-8d81-23107a12e7f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-2de7-776d-9627-5e83b8fc08b9.webp",
      "image_media": {
        "alt_text": "Two modern bar stools sit at a counter with a brick accent wall and framed abstract art.",
        "public_id": "01a03a20-2de7-776d-9627-5e83b8fc08b9",
        "storage_key": "property/6767906449167730/01a03a20-2de7-776d-9627-5e83b8fc08b9.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Study area with comfortable seating, modern design, and a decorative brick wall provides a unique space for residents to work or relax.",
      "link": "",
      "alt_text": "Two modern bar stools sit at a counter with a brick accent wall and framed abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f0bfeb40-fe09-453c-b1b3-fc898a75eb3f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-2bdf-746a-9bd9-393eb8cd1894.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with granite countertop and subway tile backsplash.",
        "public_id": "01a03a20-2bdf-746a-9bd9-393eb8cd1894",
        "storage_key": "property/6767906449167730/01a03a20-2bdf-746a-9bd9-393eb8cd1894.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring a large island with a sink and stylish subway tile accent. Includes stainless steel appliances and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen island with granite countertop and subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8c9ee41f-e935-4884-b6e7-ace0e34523dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-25b2-720c-a43d-cb8fff26d3d2.webp",
      "image_media": {
        "alt_text": "Community lounge with shuffleboard, foosball, and sectional sofa.",
        "public_id": "01a03a20-25b2-720c-a43d-cb8fff26d3d2",
        "storage_key": "property/6767906449167730/01a03a20-25b2-720c-a43d-cb8fff26d3d2.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy leisure activities in our community lounge, featuring shuffleboard, foosball, and comfortable seating.",
      "link": "",
      "alt_text": "Community lounge with shuffleboard, foosball, and sectional sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2420f5d4-a936-4ee6-bf55-dc4b02e109b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-2218-761d-aa78-0b94a4ad7c75.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and seating area",
        "public_id": "01a03a20-2218-761d-aa78-0b94a4ad7c75",
        "storage_key": "property/6767906449167730/01a03a20-2218-761d-aa78-0b94a4ad7c75.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring a large island with bar stools, ample cabinet space, and a comfortable seating area with booths and tables. Perfect for socializing or casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with island and seating area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7c5914ff-93a6-43ac-9340-c8a4b649d1f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-1bf4-71cd-afaf-32330807d1af.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with tables and chairs on a tiled patio.",
        "public_id": "01a03a20-1bf4-71cd-afaf-32330807d1af",
        "storage_key": "property/6767906449167730/01a03a20-1bf4-71cd-afaf-32330807d1af.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy comfortable outdoor seating on our spacious patio, perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Outdoor seating area with tables and chairs on a tiled patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1321dcd4-4860-43ec-bb35-0bc3bd75a962",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-170b-72ab-b0b5-4f9c9c750883.webp",
      "image_media": {
        "alt_text": "Fitness studio with mirrored walls, ballet barre, and exercise balls.",
        "public_id": "01a03a20-170b-72ab-b0b5-4f9c9c750883",
        "storage_key": "property/6767906449167730/01a03a20-170b-72ab-b0b5-4f9c9c750883.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness studio, complete with a ballet barre and a variety of exercise equipment for your workout needs.",
      "link": "",
      "alt_text": "Fitness studio with mirrored walls, ballet barre, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e86ea9a3-e621-4151-8b4a-6e4ba584108b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-0dda-7658-a59e-72372e677300.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white subway tile shower and a white bathtub.",
        "public_id": "01a03a20-0dda-7658-a59e-72372e677300",
        "storage_key": "property/6767906449167730/01a03a20-0dda-7658-a59e-72372e677300.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Relax and unwind in your spacious bathroom featuring a deep soaking tub and elegant subway tile accents.",
      "link": "",
      "alt_text": "Modern bathroom with white subway tile shower and a white bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aed45353-9a8a-4f8e-b66d-25823b7952ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a20-08b6-76e9-ad3c-a58a71089ec5.webp",
      "image_media": {
        "alt_text": "Modern lounge area with plush seating, a coffee table, and built-in bookshelves.",
        "public_id": "01a03a20-08b6-76e9-ad3c-a58a71089ec5",
        "storage_key": "property/6767906449167730/01a03a20-08b6-76e9-ad3c-a58a71089ec5.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish resident lounge, featuring comfortable seating, a coffee table, and beautifully curated bookshelves.",
      "link": "",
      "alt_text": "Modern lounge area with plush seating, a coffee table, and built-in bookshelves.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_945e8130-3207-4e6c-9a72-f38b4798f41d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-fc27-759a-8c04-f2e32dc131a5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light gray cabinets, granite countertops, stainless steel appliances, and a large island with bar stools.",
        "public_id": "01a03a1f-fc27-759a-8c04-f2e32dc131a5",
        "storage_key": "property/6767906449167730/01a03a1f-fc27-759a-8c04-f2e32dc131a5.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Discover the perfect blend of style and functionality in our modern kitchens, featuring sleek cabinetry, elegant granite countertops, and premium stainless steel appliances. Enjoy casual dining at the spacious island, ideal for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with light gray cabinets, granite countertops, stainless steel appliances, and a large island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8c485164-41b7-488e-8c85-a94d7c23cb7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-f780-73a2-9fac-bee16f75f99d.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with built-in grills, dining tables, and lounge seating.",
        "public_id": "01a03a1f-f780-73a2-9fac-bee16f75f99d",
        "storage_key": "property/6767906449167730/01a03a1f-f780-73a2-9fac-bee16f75f99d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and relaxation at our outdoor grilling station, complete with built-in BBQs, comfortable seating, and ambient lighting.",
      "link": "",
      "alt_text": "Outdoor grilling station with built-in grills, dining tables, and lounge seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_db150f5c-ca74-4a00-8113-94d5c333cce0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-fa42-770e-a236-6676b65a4e01.webp",
      "image_media": {
        "alt_text": "Double vanity with granite countertop and modern fixtures, connected to a bedroom.",
        "public_id": "01a03a1f-fa42-770e-a236-6676b65a4e01",
        "storage_key": "property/6767906449167730/01a03a1f-fa42-770e-a236-6676b65a4e01.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Elegant double vanity featuring a granite countertop and modern fixtures, offering ample space and style. Connects seamlessly to the adjacent bedroom.",
      "link": "",
      "alt_text": "Double vanity with granite countertop and modern fixtures, connected to a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d3e066d8-88b5-4a17-ab66-6857ceeb1dfe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-f3e1-77ea-acab-6ba2f2705afa.webp",
      "image_media": {
        "alt_text": "Swimming pool and lounge chairs at a luxury apartment complex.",
        "public_id": "01a03a1f-f3e1-77ea-acab-6ba2f2705afa",
        "storage_key": "property/6767906449167730/01a03a1f-f3e1-77ea-acab-6ba2f2705afa.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by comfortable lounge chairs and outdoor seating areas. Perfect for soaking up the sun or relaxing with friends.",
      "link": "",
      "alt_text": "Swimming pool and lounge chairs at a luxury apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f109c86f-60d9-4113-9d25-8e37cd44c170",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-e0e5-70bc-b021-c46199133105.webp",
      "image_media": {
        "alt_text": "Modern communal lounge area with a large island, abstract art sliding doors, and seating.",
        "public_id": "01a03a1f-e0e5-70bc-b021-c46199133105",
        "storage_key": "property/6767906449167730/01a03a1f-e0e5-70bc-b021-c46199133105.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Experience comfortable living in our modern communal lounge, featuring a sleek island, stylish seating, and unique abstract art sliding doors.",
      "link": "",
      "alt_text": "Modern communal lounge area with a large island, abstract art sliding doors, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0ef4300c-697e-40d9-8600-4a7d30a123ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-dc29-754f-a1cf-781eab30578d.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed and a view into the bathroom.",
        "public_id": "01a03a1f-dc29-754f-a1cf-781eab30578d",
        "storage_key": "property/6767906449167730/01a03a1f-dc29-754f-a1cf-781eab30578d.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant decor, and a glimpse into the adjoining modern bathroom.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed and a view into the bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5c9ff1a4-91c2-49a6-96c5-c1832ef510cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-d5f2-75ad-91e8-9ed272d76e7c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and light gray cabinets.",
        "public_id": "01a03a1f-d5f2-75ad-91e8-9ed272d76e7c",
        "storage_key": "property/6767906449167730/01a03a1f-d5f2-75ad-91e8-9ed272d76e7c.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed kitchen featuring sleek stainless steel appliances, elegant granite countertops, and ample storage space with soft-close cabinets.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and light gray cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5a29b12c-a660-44e3-be6c-698ea5b84a9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-d412-70fc-bede-e76b833d5561.webp",
      "image_media": {
        "alt_text": "Modern lobby seating area with plush chairs and a reception desk.",
        "public_id": "01a03a1f-d412-70fc-bede-e76b833d5561",
        "storage_key": "property/6767906449167730/01a03a1f-d412-70fc-bede-e76b833d5561.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax in our stylish lobby, featuring comfortable seating and a welcoming reception area.",
      "link": "",
      "alt_text": "Modern lobby seating area with plush chairs and a reception desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_38a3ef36-771d-4ee4-9498-291b5acbf5be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-d161-73cd-afbc-664201c04dd1.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with grills, tables, and a hanging chair.",
        "public_id": "01a03a1f-d161-73cd-afbc-664201c04dd1",
        "storage_key": "property/6767906449167730/01a03a1f-d161-73cd-afbc-664201c04dd1.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and relaxation in this communal space featuring grills, comfortable seating, and a unique hanging chair.",
      "link": "",
      "alt_text": "Outdoor seating area with grills, tables, and a hanging chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6cf29f3d-08e8-4514-be71-e123c12ed46a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-c69e-770b-96ff-01e05f016477.webp",
      "image_media": {
        "alt_text": "Living room with a leather sofa, armchair, and open kitchen.",
        "public_id": "01a03a1f-c69e-770b-96ff-01e05f016477",
        "storage_key": "property/6767906449167730/01a03a1f-c69e-770b-96ff-01e05f016477.webp",
        "width": 2000,
        "height": 1481
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a comfortable leather sofa and an adjacent modern kitchen with sleek cabinetry and stainless steel appliances.",
      "link": "",
      "alt_text": "Living room with a leather sofa, armchair, and open kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d5185a3e-42ea-4454-a7e3-833dca06f3ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-b9b8-739c-9058-d167711a6a9a.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with cardio equipment and large windows overlooking an outdoor patio.",
        "public_id": "01a03a1f-b9b8-739c-9058-d167711a6a9a",
        "storage_key": "property/6767906449167730/01a03a1f-b9b8-739c-9058-d167711a6a9a.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio machines and ample space for your workout routine.",
      "link": "",
      "alt_text": "Modern apartment gym with cardio equipment and large windows overlooking an outdoor patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cd58a95e-9173-4684-9426-a330a1749de6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-b77c-7429-a3a4-5cb7a5882333.webp",
      "image_media": {
        "alt_text": "Stylish communal lounge area with green sofas, tufted brown sofa, wicker coffee table, and wall art.",
        "public_id": "01a03a1f-b77c-7429-a3a4-5cb7a5882333",
        "storage_key": "property/6767906449167730/01a03a1f-b77c-7429-a3a4-5cb7a5882333.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully designed communal lounge, featuring plush seating, a modern chandelier, and ample space for residents to gather.",
      "link": "",
      "alt_text": "Stylish communal lounge area with green sofas, tufted brown sofa, wicker coffee table, and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_55622601-ac68-49c9-b832-d8f4e4dd30c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-ac47-707e-8bf5-8dc726dc90f9.webp",
      "image_media": {
        "alt_text": "Fitness center with exercise bikes, rowing machines, and stability balls.",
        "public_id": "01a03a1f-ac47-707e-8bf5-8dc726dc90f9",
        "storage_key": "property/6767906449167730/01a03a1f-ac47-707e-8bf5-8dc726dc90f9.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment and free weights for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with exercise bikes, rowing machines, and stability balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_863ddac5-9ddd-4f6f-bfa1-c1f12acab1f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-a991-7400-926f-7f02d9592959.webp",
      "image_media": {
        "alt_text": "Modern lounge area with comfortable seating, shelving, and a TV.",
        "public_id": "01a03a1f-a991-7400-926f-7f02d9592959",
        "storage_key": "property/6767906449167730/01a03a1f-a991-7400-926f-7f02d9592959.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish resident lounge, featuring plush seating, a large TV, and decorative shelving for a welcoming atmosphere.",
      "link": "",
      "alt_text": "Modern lounge area with comfortable seating, shelving, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5427648e-4b99-44dc-9a8b-118484773752",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-967e-771d-af64-d6331b2f6bf6.webp",
      "image_media": {
        "alt_text": "Clubhouse common area with seating, games, and a bar.",
        "public_id": "01a03a1f-967e-771d-af64-d6331b2f6bf6",
        "storage_key": "property/6767906449167730/01a03a1f-967e-771d-af64-d6331b2f6bf6.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish clubhouse common area, featuring comfortable seating, fun games, and a convenient bar for resident use.",
      "link": "",
      "alt_text": "Clubhouse common area with seating, games, and a bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21fda71c-c2ee-4963-b50f-01b940f796e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-8458-7278-9b08-33dd0ea3a060.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with island, stainless steel appliances, and natural light.",
        "public_id": "01a03a1f-8458-7278-9b08-33dd0ea3a060",
        "storage_key": "property/6767906449167730/01a03a1f-8458-7278-9b08-33dd0ea3a060.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment featuring an open-concept living area and a fully equipped kitchen with a large island. Enjoy ample natural light and stylish finishes.",
      "link": "",
      "alt_text": "Modern kitchen and living area with island, stainless steel appliances, and natural light.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7f30d90f-dd79-409c-b651-349fc43daa82",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-80ac-751a-9efc-d9d79c03cb04.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and an island with decorative tiling.",
        "public_id": "01a03a1f-80ac-751a-9efc-d9d79c03cb04",
        "storage_key": "property/6767906449167730/01a03a1f-80ac-751a-9efc-d9d79c03cb04.webp",
        "width": 1280,
        "height": 720
      },
      "title": "Apartment",
      "description": "Discover this stunning kitchen featuring stainless steel appliances, elegant granite countertops, and a unique tiled island, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and an island with decorative tiling.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0edbc390-3568-4bbc-866d-ad357a52319a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-8073-759f-9167-eefba6879905.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a03a1f-8073-759f-9167-eefba6879905",
        "storage_key": "property/6767906449167730/01a03a1f-8073-759f-9167-eefba6879905.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling resort-style pool, surrounded by comfortable lounge chairs and beautiful apartment buildings.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f9ac3388-f11e-4e38-935b-2dbf71ddf628",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-80d3-757d-9291-c849227af1e7.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with stainless steel appliances and large windows.",
        "public_id": "01a03a1f-80d3-757d-9291-c849227af1e7",
        "storage_key": "property/6767906449167730/01a03a1f-80d3-757d-9291-c849227af1e7.webp",
        "width": 1280,
        "height": 720
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment featuring a well-equipped kitchen with granite countertops and a seamless flow into the living area.",
      "link": "",
      "alt_text": "Modern kitchen and living area with stainless steel appliances and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bd1960b3-0f5d-4c89-80ba-eafec19f5eaa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1f-7e0d-73c6-acfe-83212a3ac5d5.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with sink and faucet, open to living area with ceiling fan and windows.",
        "public_id": "01a03a1f-7e0d-73c6-acfe-83212a3ac5d5",
        "storage_key": "property/6767906449167730/01a03a1f-7e0d-73c6-acfe-83212a3ac5d5.webp",
        "width": 1280,
        "height": 720
      },
      "title": "Apartment",
      "description": "Spacious living area and modern kitchen featuring a large island, stainless steel appliances, and ample natural light.",
      "link": "",
      "alt_text": "Modern kitchen island with sink and faucet, open to living area with ceiling fan and windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2da276cb-b433-4b13-9b2e-b62e49dbf34a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1d-a8e4-75dd-b465-d84e0ad3878c.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with plush seating, built-in bookshelves, and modern decor.",
        "public_id": "01a03a1d-a8e4-75dd-b465-d84e0ad3878c",
        "storage_key": "property/6767906449167730/01a03a1d-a8e4-75dd-b465-d84e0ad3878c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed resident lounge, featuring comfortable seating, a curated library, and a sophisticated ambiance perfect for socializing or quiet reflection.",
      "link": "",
      "alt_text": "Stylish lounge area with plush seating, built-in bookshelves, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5c4f9eb9-2b50-4983-a0ba-4eea19536b2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1d-9df4-73f8-8d7f-a743aa0f36c9.webp",
      "image_media": {
        "alt_text": "Elliptical machines and treadmills in a well-lit fitness center with large windows.",
        "public_id": "01a03a1d-9df4-73f8-8d7f-a743aa0f36c9",
        "storage_key": "property/6767906449167730/01a03a1d-9df4-73f8-8d7f-a743aa0f36c9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring modern cardio equipment and plenty of natural light.",
      "link": "",
      "alt_text": "Elliptical machines and treadmills in a well-lit fitness center with large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_352ddee4-759b-4253-8660-ba7b6bb034b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1d-99cb-7489-adb2-11f15829d6c4.webp",
      "image_media": {
        "alt_text": "Modern living room with grey sectional couch, artwork of horses, and decorative shelves.",
        "public_id": "01a03a1d-99cb-7489-adb2-11f15829d6c4",
        "storage_key": "property/6767906449167730/01a03a1d-99cb-7489-adb2-11f15829d6c4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this stylish living area, featuring a comfortable sectional sofa and unique horse-themed artwork that adds a touch of equestrian charm.",
      "link": "",
      "alt_text": "Modern living room with grey sectional couch, artwork of horses, and decorative shelves.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_67f4a631-704f-4c74-967c-af4d5ab36211",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1d-8f97-7736-b9d4-963e41c7f84d.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with grilling stations and a unique hanging chair.",
        "public_id": "01a03a1d-8f97-7736-b9d4-963e41c7f84d",
        "storage_key": "property/6767906449167730/01a03a1d-8f97-7736-b9d4-963e41c7f84d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and relaxation in our beautifully designed community area, complete with grills and comfortable seating.",
      "link": "",
      "alt_text": "Outdoor seating area with grilling stations and a unique hanging chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e47f9264-703c-4520-b4e8-628ec8c0ee3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1d-8ef2-71b7-bee7-079cb36b3c82.webp",
      "image_media": {
        "alt_text": "King-size bed with white linens in a bedroom, view of an en-suite bathroom",
        "public_id": "01a03a1d-8ef2-71b7-bee7-079cb36b3c82",
        "storage_key": "property/6767906449167730/01a03a1d-8ef2-71b7-bee7-079cb36b3c82.webp",
        "width": 2999,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Step into comfort in this spacious bedroom, featuring a king-size bed and elegant decor. The adjoining en-suite bathroom adds a touch of luxury.",
      "link": "",
      "alt_text": "King-size bed with white linens in a bedroom, view of an en-suite bathroom",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c8330aea-691d-450d-941a-d4d0cb48181b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-e684-741b-835b-e777d0c01774.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, desk, and windows.",
        "public_id": "01a03a1c-e684-741b-835b-e777d0c01774",
        "storage_key": "property/6767906449167730/01a03a1c-e684-741b-835b-e777d0c01774.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed with decorative pillows and a patterned throw blanket. A wooden desk with a chair is positioned next to a lamp, and artwork adorns the wall above the bed. Large windows allow natural light to fill the space.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, desk, and windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7e279587-5b23-434b-b8b7-599579d98965",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-e684-741b-835b-e054ea5e64d5.webp",
      "image_media": {
        "alt_text": "Gym with cable machine, weight racks, dumbbells, kettlebells, and a neon sign.",
        "public_id": "01a03a1c-e684-741b-835b-e054ea5e64d5",
        "storage_key": "property/6767906449167730/01a03a1c-e684-741b-835b-e054ea5e64d5.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a full range of weight and cardio equipment, perfect for achieving your wellness goals.",
      "link": "",
      "alt_text": "Gym with cable machine, weight racks, dumbbells, kettlebells, and a neon sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0a858ecd-0ecb-4d13-8f3a-7bbefc173d28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-e684-741b-835b-e99621082e9f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and living room view",
        "public_id": "01a03a1c-e684-741b-835b-e99621082e9f",
        "storage_key": "property/6767906449167730/01a03a1c-e684-741b-835b-e99621082e9f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Stylish open-concept living space featuring a modern kitchen with a large island, sleek cabinetry, and an adjacent living area, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with island and living room view",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bc81fcb6-d153-4a3f-9e4b-9d61d4f658ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-e686-70b8-a158-cd9f85c37efa.webp",
      "image_media": {
        "alt_text": "Modern living room with stylish furniture and a view into the bedroom.",
        "public_id": "01a03a1c-e686-70b8-a158-cd9f85c37efa",
        "storage_key": "property/6767906449167730/01a03a1c-e686-70b8-a158-cd9f85c37efa.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this beautifully appointed apartment living room, featuring chic furnishings and a glimpse of a serene bedroom.",
      "link": "",
      "alt_text": "Modern living room with stylish furniture and a view into the bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2d69576c-1717-4415-96a5-e9a69682c2a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-e42a-723f-8786-452986b3c6c8.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with bookshelves and a glass-walled conference room.",
        "public_id": "01a03a1c-e42a-723f-8786-452986b3c6c8",
        "storage_key": "property/6767906449167730/01a03a1c-e42a-723f-8786-452986b3c6c8.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and collaborate in our stylish lounge area featuring comfortable seating, extensive bookshelves, and a fully equipped conference room.",
      "link": "",
      "alt_text": "Comfortable seating area with bookshelves and a glass-walled conference room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_f7e479eca5fb5e23465f923f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Boulevard Cafe",
      "poi_type": "Restaurants",
      "poi_address": "5121 Davis Blvd, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Casual, family-owned eatery serving classic American fare like burgers and pancakes, as well as breakfast items.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-53b7-703a-8364-3e897210c458.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-53b7-703a-8364-3e897210c458",
        "storage_key": "property/6767906449167730/01a03a1e-53b7-703a-8364-3e897210c458.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14429577624382289331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boulevard-cafe",
      "poi_latitude": "32.8407018",
      "poi_longitude": "-97.2148355",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-849-2231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-984a3b5ee372",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bzNBPF4ToYRszU78GUoQMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_6c89df88cb43bf92aa2fcaaa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Sunny Street Café",
      "poi_type": "Restaurants",
      "poi_address": "6021 Walker Blvd, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Casual regional chain serving hearty American fare for breakfast & lunch, with gluten-free options.",
      "poi_long_description": "Casual regional chain serving hearty American fare for breakfast & lunch, with gluten-free options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-58af-70c9-9bd5-93dae79cf95c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-58af-70c9-9bd5-93dae79cf95c",
        "storage_key": "property/6767906449167730/01a03a1e-58af-70c9-9bd5-93dae79cf95c.webp",
        "width": 1280,
        "height": 686
      },
      "poi_business_url": "http://www.sunnystreetcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15510697994927395485&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunny-street-caf",
      "poi_latitude": "32.8532013",
      "poi_longitude": "-97.1905732",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-485-1818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-984a3b5ee372",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7QnhT9t5ToYRndICrqURQdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_fa23bf6f5e13de71e3b36020",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "First Watch",
      "poi_type": "Restaurants",
      "poi_address": "9159 Blvd 26 Ste. 360, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_long_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-593e-7548-9125-f79815589ac0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-593e-7548-9125-f79815589ac0",
        "storage_key": "property/6767906449167730/01a03a1e-593e-7548-9125-f79815589ac0.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.firstwatch.com/locations/north-richland-hills/?utm_source=gbp-listing&utm_medium=organic&utm_campaign=gbp-listing&utm_content=north-richland-hills",
      "poi_directions_map_url": "https://maps.google.com/?cid=2849685257810010772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-watch",
      "poi_latitude": "32.8553749",
      "poi_longitude": "-97.1876348",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-427-3444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-984a3b5ee372",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlc18Lrd4ToYRlOJuyaQdjCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_8775603b1f021c32a10d2b2b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Heavenly Crust Pizza",
      "poi_type": "Restaurants",
      "poi_address": "8721 Blvd 26, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Casual option for thin-crust, NY-style pizzas (many are jumbo-sized) alongside salads and lasagna.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-558f-743c-b771-3852f1303ca5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-558f-743c-b771-3852f1303ca5",
        "storage_key": "property/6767906449167730/01a03a1e-558f-743c-b771-3852f1303ca5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://heavenlycrust.com/north-richland-hills?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=9892364473966148819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heavenly-crust-pizza",
      "poi_latitude": "32.8468249",
      "poi_longitude": "-97.1973396",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-479-3077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-984a3b5ee372",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOZpo_vx5ToYR0zxyuxO9SIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_82b2fc245ae9a38599aa27c3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Taqueria Taxco",
      "poi_type": "Restaurants",
      "poi_address": "7605 Blvd 26, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-559e-77e8-b0f5-5eeb588a0b9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-559e-77e8-b0f5-5eeb588a0b9f",
        "storage_key": "property/6767906449167730/01a03a1e-559e-77e8-b0f5-5eeb588a0b9f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ttaxco.com/taqueriataxconorthrichlandhills?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=9934870113484014753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taqueria-taxco",
      "poi_latitude": "32.8310234",
      "poi_longitude": "-97.218878",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-984a3b5ee372",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8azHGx55ToYRoQTcI7u_34k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_1418e172836ed528150efc7a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "McAlister's Deli",
      "poi_type": "Restaurants",
      "poi_address": "9143 Blvd 26 Suite 600, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Easygoing counter-service chain known for its sandwiches, stuffed baked potatoes & sweet tea.",
      "poi_long_description": "Easygoing counter-service chain known for its sandwiches, stuffed baked potatoes & sweet tea.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-57e9-75d1-83b1-8eacb7f3bd55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-57e9-75d1-83b1-8eacb7f3bd55",
        "storage_key": "property/6767906449167730/01a03a1e-57e9-75d1-83b1-8eacb7f3bd55.webp",
        "width": 1280,
        "height": 1072
      },
      "poi_business_url": "https://locations.mcalistersdeli.com/tx/north-richland-hills/9143-boulevard-26?utm_source=google&utm_medium=organic&utm_campaign=locations_partner",
      "poi_directions_map_url": "https://maps.google.com/?cid=2908520833719858370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcalisters-deli",
      "poi_latitude": "32.8544208",
      "poi_longitude": "-97.1885295",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-485-3354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-984a3b5ee372",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB2SWysB4ToYRwvSxy0kkXSg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "ec_7098e8efb9df254d23a6b83e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Barrel & Bones Craft Bar and Smokehouse",
      "poi_type": "Restaurants",
      "poi_address": "9143 Grapevine Hwy #620, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-5b0c-73fc-bc70-98580b55dff8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-5b0c-73fc-bc70-98580b55dff8",
        "storage_key": "property/6767906449167730/01a03a1e-5b0c-73fc-bc70-98580b55dff8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://orders.barrelandbones.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7419959058276983226&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barrel--bones-craft-bar-and-smokehouse",
      "poi_latitude": "32.8546223",
      "poi_longitude": "-97.1884974",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-393-3118",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-984a3b5ee372",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2mEbm95ToYRuqGKbHP9-GY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_c8cead3a3adc2cb1ef72c396",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Sushi Avenue NRH",
      "poi_type": "Restaurants",
      "poi_address": "9143 Blvd 26 #650, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Informal Japanese eatery featuring a variety of sushi rolls in a cozy atmosphere.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-53ae-75fa-a8a0-f1e9476cd430.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-53ae-75fa-a8a0-f1e9476cd430",
        "storage_key": "property/6767906449167730/01a03a1e-53ae-75fa-a8a0-f1e9476cd430.webp",
        "width": 942,
        "height": 1280
      },
      "poi_business_url": "http://www.txsushiavenue.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11943856799890368872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushi-avenue-nrh",
      "poi_latitude": "32.8547245",
      "poi_longitude": "-97.1885061",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-393-3464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-984a3b5ee372",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBTz_oGF5ToYRaGmZbXoawaU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_cdfe8d32486a9b2b29d051dc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Babe's Chicken Dinner House",
      "poi_type": "Restaurants",
      "poi_address": "6700 NE Loop 820, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Relaxed local chain serving fried chicken & homestyle American sides in a rustic setting.",
      "poi_long_description": "Relaxed local chain serving fried chicken & homestyle American sides in a rustic setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-706d-71f4-9d2d-4c9d2bdbe410.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1c-706d-71f4-9d2d-4c9d2bdbe410",
        "storage_key": "property/6767906449167730/01a03a1c-706d-71f4-9d2d-4c9d2bdbe410.webp",
        "width": 1126,
        "height": 804
      },
      "poi_business_url": "https://babeschicken.com/?y_source=1_MjAyMjkwMzQ0Mi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5977819841032846300&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "babes-chicken-dinner-house",
      "poi_latitude": "32.839435",
      "poi_longitude": "-97.237305",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-428-4298",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-984a3b5ee372",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW563zIt5ToYR3HsLPHl79VI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "ec_ccd734fae99e13976de298a2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Ernie's Seafood Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "8206 Bedford Euless Rd, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Fried seafood anchors this casual eatery, also serving landlubber eats, in a cheerful, basic space.",
      "poi_long_description": "Fried seafood anchors this casual eatery, also serving landlubber eats, in a cheerful, basic space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-561e-745b-89fb-94a771c4e44d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-561e-745b-89fb-94a771c4e44d",
        "storage_key": "property/6767906449167730/01a03a1e-561e-745b-89fb-94a771c4e44d.webp",
        "width": 1280,
        "height": 817
      },
      "poi_business_url": "http://www.erniesseafood.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13890713608113448636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ernies-seafood-restaurant",
      "poi_latitude": "32.8337497",
      "poi_longitude": "-97.2054229",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-498-5511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-984a3b5ee372",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1ickOZ4ToYRvGZJMG66xcA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_70b59581cb2c7950246d1f36",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "King Crab House",
      "poi_type": "Restaurants",
      "poi_address": "8000 Bedford Euless Rd, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Boisterous restaurant specializing in seafood boil combos such as snow crab legs and shrimp, plus fried options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-5393-73fa-9ee9-9639d351bef9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-5393-73fa-9ee9-9639d351bef9",
        "storage_key": "property/6767906449167730/01a03a1e-5393-73fa-9ee9-9639d351bef9.webp",
        "width": 1133,
        "height": 1280
      },
      "poi_business_url": "https://kingcrabhousenrh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4474140984221247556&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-crab-house",
      "poi_latitude": "32.833859",
      "poi_longitude": "-97.2082508",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-631-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-984a3b5ee372",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTXHAW-R4ToYRRCiGJ4VXFz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_53ee6e7ec456725973dd1f62",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Mariscos el Malecon Bar and Grill",
      "poi_type": "Restaurants",
      "poi_address": "7630 NE Loop 820, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-5f58-72ee-ae27-4c18c4b33aa0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-5f58-72ee-ae27-4c18c4b33aa0",
        "storage_key": "property/6767906449167730/01a03a1e-5f58-72ee-ae27-4c18c4b33aa0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://maleconseafood.carrd.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17020265431599007452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mariscos-el-malecon-bar-and-grill",
      "poi_latitude": "32.8325831",
      "poi_longitude": "-97.2180567",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-576-4520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-984a3b5ee372",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXytfx0B5ToYR3MZRmTshNOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_ecd058288d933aacefe1d10f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Herbs Indian Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "TOM THUMB Plaza, 660 Grapevine Hwy, Hurst, TX 76054, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-5b83-75a4-a12c-07ec8910a58a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-5b83-75a4-a12c-07ec8910a58a",
        "storage_key": "property/6767906449167730/01a03a1e-5b83-75a4-a12c-07ec8910a58a.webp",
        "width": 1280,
        "height": 787
      },
      "poi_business_url": "https://herbsindianhurst.com/page/home/",
      "poi_directions_map_url": "https://maps.google.com/?cid=517463871021833660&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "herbs-indian-cuisine",
      "poi_latitude": "32.8628142",
      "poi_longitude": "-97.1801625",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-479-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-984a3b5ee372",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqQbOt0J5ToYRvN1aKKZmLgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "north_indian_restaurant"
    },
    {
      "id": "ec_7c22876ed928e3183c29c2f7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Mama's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "1700 Precinct Line Rd, Hurst, TX 76054, USA",
      "poi_short_description": "Counter-serve outpost of a longtime local chain offering thin-crust pizza baked in brick ovens.",
      "poi_long_description": "Counter-serve outpost of a longtime local chain offering thin-crust pizza baked in brick ovens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-5b1f-75fa-870e-efec8829f707.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-5b1f-75fa-870e-efec8829f707",
        "storage_key": "property/6767906449167730/01a03a1e-5b1f-75fa-870e-efec8829f707.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mamaspizzanrh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12802792444527857804&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mamas-pizza",
      "poi_latitude": "32.8457172",
      "poi_longitude": "-97.1855598",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-281-0571",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-984a3b5ee372",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-984a3b5ee372.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJa19_hLh4ToYRjFAjbeWnrLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_596fc771ce2dbf9a0b9248cf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "6401 NE Loop 820, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Large discount store selling groceries and bulk products, plus offering pharmacy and photo services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-60f9-76b9-b53e-20caa178f655.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-60f9-76b9-b53e-20caa178f655",
        "storage_key": "property/6767906449167730/01a03a1e-60f9-76b9-b53e-20caa178f655.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/807-north-richland-hills-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11046904516877339273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "32.8426368",
      "poi_longitude": "-97.2465756",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-577-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-90ea65c843a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-90ea65c843a7",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-90ea65c843a7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7U100Th4ToYRicohDCF9Tpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_89eacbbd0f3cf34fce12fcca",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "6375 NE Loop 820, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-5f1b-77f0-abf5-342df8f2d35b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-5f1b-77f0-abf5-342df8f2d35b",
        "storage_key": "property/6767906449167730/01a03a1e-5f1b-77f0-abf5-342df8f2d35b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/8268-north-richland-hills-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15915106349710848823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "32.8423823",
      "poi_longitude": "-97.2487441",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-428-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-90ea65c843a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-90ea65c843a7",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-90ea65c843a7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4Ud_oT54ToYRNzMUOefQ3dw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_18ca6bbc14b2680e8145385a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "5152 Rufe Snow Dr, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-5fca-7760-bc8d-d96a0af42686.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-5fca-7760-bc8d-d96a0af42686",
        "storage_key": "property/6767906449167730/01a03a1e-5fca-7760-bc8d-d96a0af42686.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4675301932234257860&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "32.8428632",
      "poi_longitude": "-97.2354999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-479-9711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdc3-73db-bed7-4b6554106553.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdc3-73db-bed7-4b6554106553",
        "storage_key": "property/6767906449167730/01a03a1c-bdc3-73db-bed7-4b6554106553.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqRGjmUN4ToYRxDWFKFYC4kA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_4048649310fc022c56ca0a8b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "6320 Rufe Snow Dr, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-622c-7429-9fe4-3a9049d72b0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-622c-7429-9fe4-3a9049d72b0e",
        "storage_key": "property/6767906449167730/01a03a1e-622c-7429-9fe4-3a9049d72b0e.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/north-richland-hills-tx-pharmacies/6320-rufe-snow-dr-north-richland-hills-tx-76180/storeid=8330?WT.mc_id=LS_GOOGLE_RX_8330",
      "poi_directions_map_url": "https://maps.google.com/?cid=9853277291459168509&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.8608013",
      "poi_longitude": "-97.237507",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-656-9861",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-a2ff-7372-b1c0-142783182bce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1e-a2ff-7372-b1c0-142783182bce",
        "storage_key": "property/6767906449167730/01a03a1e-a2ff-7372-b1c0-142783182bce.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWVGgm3F4ToYR_cjY3n3fvYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_bfb413dd6365ccba25cbfdc0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "6350 Davis Blvd, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-61a8-70be-8ab1-509ed7c735f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-61a8-70be-8ab1-509ed7c735f9",
        "storage_key": "property/6767906449167730/01a03a1e-61a8-70be-8ab1-509ed7c735f9.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-6350+davis+blvd-north+richland+hills-tx-76180/id=6631",
      "poi_directions_map_url": "https://maps.google.com/?cid=6114079708713130278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.8615379",
      "poi_longitude": "-97.2084957",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-498-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTxAsaZp4ToYRJhlF7hmT2VQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_e62eed49515462450a917ec3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "QuikTrip",
      "poi_type": "Transportation & Transit",
      "poi_address": "6640 NE Loop 820, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-62f5-7788-9fca-ffe5ccb530d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-62f5-7788-9fca-ffe5ccb530d4",
        "storage_key": "property/6767906449167730/01a03a1e-62f5-7788-9fca-ffe5ccb530d4.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/tx/north-richland-hills/6640-ne-loop-820?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDQ1MzItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12610259711389977235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "32.8391028",
      "poi_longitude": "-97.2394587",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-485-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-a2ea-7549-95ad-6ccce0f80b47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1e-a2ea-7549-95ad-6ccce0f80b47",
        "storage_key": "property/6767906449167730/01a03a1e-a2ea-7549-95ad-6ccce0f80b47.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJvZaYjUZ4ToYRk8rRPmWkAK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_7d8b76d0edfe49c23a71d251",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "6360 Davis Blvd, North Richland Hills, TX 76182, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-63e9-7629-a7e5-9d37e2c1fcb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-63e9-7629-a7e5-9d37e2c1fcb1",
        "storage_key": "property/6767906449167730/01a03a1e-63e9-7629-a7e5-9d37e2c1fcb1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tx/north-richland-hills/6360-davis-blvd-34096",
      "poi_directions_map_url": "https://maps.google.com/?cid=17897308631209433943&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "32.8627703",
      "poi_longitude": "-97.2081264",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-427-1251",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-a306-7729-b8ff-31a114574fdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1e-a306-7729-b8ff-31a114574fdf",
        "storage_key": "property/6767906449167730/01a03a1e-a306-7729-b8ff-31a114574fdf.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJh0jbIvN4ToYRV1vFRmADYPg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_8d36382d68c6e82bd4f1d0be",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "6501 NE Loop 820, Richland Hills, TX 76180, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-74f3-709c-a1e8-99d5e13ebca7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-74f3-709c-a1e8-99d5e13ebca7",
        "storage_key": "property/6767906449167730/01a03a1e-74f3-709c-a1e8-99d5e13ebca7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.homedepot.com/l/North-Richland/TX/N-Richland-Hills/76180/540?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6177776070723312560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "32.8421273",
      "poi_longitude": "-97.2432448",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-485-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-90ea65c843a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-90ea65c843a7",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-90ea65c843a7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJTqQpkB4ToYRsBtf5Zreu1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_b029de778b0f6ffc4ce38c7f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Academy Sports + Outdoors",
      "poi_type": "Shopping & Retail",
      "poi_address": "7441 NE Loop 820, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Sporting goods chain selling athletic apparel & footwear, plus outdoor gear & fitness equipment.",
      "poi_long_description": "Sporting goods chain selling athletic apparel & footwear, plus outdoor gear & fitness equipment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-6483-7517-83b7-d91faeadbb79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-6483-7517-83b7-d91faeadbb79",
        "storage_key": "property/6767906449167730/01a03a1e-6483-7517-83b7-d91faeadbb79.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.academy.com/storelocator/texas/north-richland-hills/store-0076",
      "poi_directions_map_url": "https://maps.google.com/?cid=7432291525892577770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "academy-sports--outdoors",
      "poi_latitude": "32.8369113",
      "poi_longitude": "-97.2208951",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-514-3140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-90ea65c843a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-90ea65c843a7",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-90ea65c843a7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwU0qCPh4ToYR6hn5y8PNJGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "ec_ab9614bbb7211659640ccf16",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Burlington",
      "poi_type": "Shopping & Retail",
      "poi_address": "6537 NE Loop 820, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Discount chain selling name-brand clothing, shoes and home goods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-6512-76bb-84a0-52b0087c358f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-6512-76bb-84a0-52b0087c358f",
        "storage_key": "property/6767906449167730/01a03a1e-6512-76bb-84a0-52b0087c358f.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.burlington.com/stores/tx/north-richland-hills/559?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=4786198690897683346&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burlington",
      "poi_latitude": "32.8421496",
      "poi_longitude": "-97.2420648",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-788-8572",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-90ea65c843a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-90ea65c843a7",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-90ea65c843a7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAxZRyUB4ToYRkmNl21n-a0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "ec_294481ebd0e41eed3f090294",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Snow Heights Elementary School",
      "poi_type": "Education",
      "poi_address": "4801 Vance Rd, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-6cf9-70bc-92f7-b31639c5a15c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-6cf9-70bc-92f7-b31639c5a15c",
        "storage_key": "property/6767906449167730/01a03a1e-6cf9-70bc-92f7-b31639c5a15c.webp",
        "width": 1182,
        "height": 827
      },
      "poi_business_url": "https://www.birdvilleschools.net/she",
      "poi_directions_map_url": "https://maps.google.com/?cid=94097040233660211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "snow-heights-elementary-school",
      "poi_latitude": "32.8351323",
      "poi_longitude": "-97.2336056",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-547-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-942c455fb6b2",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuQmm5k94ToYRM_-KccJMTgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_fbb2a4b92ebc1d4a98a65f86",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "North Richland Middle School",
      "poi_type": "Education",
      "poi_address": "4801 Redondo St, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-6805-766e-8d91-b4453141b9c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-6805-766e-8d91-b4453141b9c8",
        "storage_key": "property/6767906449167730/01a03a1e-6805-766e-8d91-b4453141b9c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://northrichlandmiddle.birdvilleschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9687906655089512095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-richland-middle-school",
      "poi_latitude": "32.8356242",
      "poi_longitude": "-97.2354324",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-547-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-942c455fb6b2",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbbdGtkh4ToYRn87AKcZbcoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_6384a662dbcbf386ea147bd3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Richland High School",
      "poi_type": "Education",
      "poi_address": "5201 Holiday Ln, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-6738-70f4-9c7f-64dd1e816a74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-6738-70f4-9c7f-64dd1e816a74",
        "storage_key": "property/6767906449167730/01a03a1e-6738-70f4-9c7f-64dd1e816a74.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://schools.birdvilleschools.net/rhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=14968800648718811530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richland-high-school",
      "poi_latitude": "32.842597",
      "poi_longitude": "-97.2299813",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-547-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-942c455fb6b2",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ362XbFx4ToYRioGFxOHcu88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_4bcaac5cbb5a11cae204b5ba",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Birdville High School",
      "poi_type": "Education",
      "poi_address": "9100 Mid Cities Blvd, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-67e9-77cf-bc50-badf299d5918.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-67e9-77cf-bc50-badf299d5918",
        "storage_key": "property/6767906449167730/01a03a1e-67e9-77cf-bc50-badf299d5918.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.birdvilleschools.net/bhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=17691209623955527921&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "birdville-high-school",
      "poi_latitude": "32.8611675",
      "poi_longitude": "-97.192094",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-547-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-942c455fb6b2",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu8Ayt7p4ToYR8VjXwmvNg_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_2842cde55e542f11cb0cdf43",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Birdville Center of Technology and Advanced Learning",
      "poi_type": "Education",
      "poi_address": "7020 Mid Cities Blvd, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-69a0-730e-bcd1-96b43ca04025.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-69a0-730e-bcd1-96b43ca04025",
        "storage_key": "property/6767906449167730/01a03a1e-69a0-730e-bcd1-96b43ca04025.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.birdvilleschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1561341691854099278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "birdville-center-of-technology-and-advanced-learning",
      "poi_latitude": "32.8597084",
      "poi_longitude": "-97.2325595",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-547-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-942c455fb6b2",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjUKoVmV4ToYRTpP4E___qhU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_077cb6059f3a4a9a8326ef79",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Tarrant County College - Northeast Campus",
      "poi_type": "Education",
      "poi_address": "828 W Harwood Rd, Hurst, TX 76054, USA",
      "poi_short_description": "On-campus shop selling college books, apparel, school supplies, computers, software & electronics.",
      "poi_long_description": "On-campus shop selling college books, apparel, school supplies, computers, software & electronics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-7590-700a-a78c-ede20b5aa0f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1c-7590-700a-a78c-ede20b5aa0f9",
        "storage_key": "property/6767906449167730/01a03a1c-7590-700a-a78c-ede20b5aa0f9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tccd.edu/locations/northeast-campus/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6601226914742018412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tarrant-county-college---northeast-campus",
      "poi_latitude": "32.84692560000001",
      "poi_longitude": "-97.1917037",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-515-8223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-942c455fb6b2",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV-TYe8h4ToYRbCHydudEnFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_16a8e49472817efcd42e2d1e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Remington College Fort Worth Campus",
      "poi_type": "Education",
      "poi_address": "5555 Rufe Snow Dr Ste 150, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-6996-7176-b5d9-f663d7e6e2ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-6996-7176-b5d9-f663d7e6e2ef",
        "storage_key": "property/6767906449167730/01a03a1e-6996-7176-b5d9-f663d7e6e2ef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.remingtoncollege.edu/locations/fort-worth",
      "poi_directions_map_url": "https://maps.google.com/?cid=6767601627158111600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "remington-college-fort-worth-campus",
      "poi_latitude": "32.8474528",
      "poi_longitude": "-97.2407613",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-451-0017",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-942c455fb6b2",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG103L9d7ToYRcGUd2NJZ610",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_015e05168bfcb15846ca42e3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Little Tyke Learning Centers",
      "poi_type": "Education",
      "poi_address": "8204 Blvd 26, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Chain of centers providing day-care services for infants and Pre-K students, together with after-school activities.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-69e7-758b-9b70-1877a800fa1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-69e7-758b-9b70-1877a800fa1f",
        "storage_key": "property/6767906449167730/01a03a1e-69e7-758b-9b70-1877a800fa1f.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://littletykechildcare.com/location/north-richland-hills/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3613268451338570402&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-tyke-learning-centers",
      "poi_latitude": "32.8402363",
      "poi_longitude": "-97.2049555",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-281-7387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-942c455fb6b2",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR7T83Oh4ToYRokopOIPoJDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_53ae621a9c0b9fe9a3c6bdba",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "The Children's Courtyard of NRH/Keller",
      "poi_type": "Education",
      "poi_address": "8521 Davis Blvd, North Richland Hills, TX 76182, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-6b17-7717-bbe6-4c57346af859.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-6b17-7717-bbe6-4c57346af859",
        "storage_key": "property/6767906449167730/01a03a1e-6b17-7717-bbe6-4c57346af859.webp",
        "width": 711,
        "height": 400
      },
      "poi_business_url": "https://www.childrenscourtyard.com/your-local-school/north-richland-hills-tx-3252/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=3252",
      "poi_directions_map_url": "https://maps.google.com/?cid=11747632409286257224&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-childrens-courtyard-of-nrhkeller",
      "poi_latitude": "32.9078284",
      "poi_longitude": "-97.1927916",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 866-561-3412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-942c455fb6b2",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0x1v0RzXTYYRSKpfQ2_5B6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_2a2f1b7e3869a5747db598c1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Smithfield Elementary School",
      "poi_type": "Education",
      "poi_address": "8001 Northeast Pkwy, North Richland Hills, TX 76182, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-6bce-744c-9e27-d745623021ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-6bce-744c-9e27-d745623021ff",
        "storage_key": "property/6767906449167730/01a03a1e-6bce-744c-9e27-d745623021ff.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "http://birdvilleschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12384686449225711533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smithfield-elementary-school",
      "poi_latitude": "32.8702062",
      "poi_longitude": "-97.2098395",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-547-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-942c455fb6b2",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-942c455fb6b2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ-OuyYJ4ToYRrT-xbLU-36s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_1634947e434cf143708c185f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Iron Horse Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6200 Skylark Cir, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Golf course featuring a driving range along with weddings and event hosting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-86bf-71c8-a752-a1f3350ac823.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1c-86bf-71c8-a752-a1f3350ac823",
        "storage_key": "property/6767906449167730/01a03a1c-86bf-71c8-a752-a1f3350ac823.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ironhorsetx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6331014570284465398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iron-horse-golf-course",
      "poi_latitude": "32.8358804",
      "poi_longitude": "-97.2543562",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-485-6666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd1-711e-9bc2-5aea34b1f4bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd1-711e-9bc2-5aea34b1f4bb",
        "storage_key": "property/6767906449167730/01a03a1c-bdd1-711e-9bc2-5aea34b1f4bb.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJeyfzeC94ToYR9rygYTVI3Fc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "ec_41b01b7a32d13b5c2dcd46c0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Platinum Music Complex NRH",
      "poi_type": "Shopping & Retail",
      "poi_address": "7301 NE Loop 820, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-7038-72ad-b3ed-d892e4369a47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-7038-72ad-b3ed-d892e4369a47",
        "storage_key": "property/6767906449167730/01a03a1e-7038-72ad-b3ed-d892e4369a47.webp",
        "width": 1200,
        "height": 490
      },
      "poi_business_url": "https://platinummusiccomplex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7520549636382176204&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "platinum-music-complex-nrh",
      "poi_latitude": "32.8380239",
      "poi_longitude": "-97.2249231",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 682-540-3019",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda9-734f-9680-90ea65c843a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda9-734f-9680-90ea65c843a7",
        "storage_key": "property/6767906449167730/01a03a1c-bda9-734f-9680-90ea65c843a7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJiY0RTIB5ToYRzLNAeAxcXmg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_a455b35329caead25739c86f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Catapult Adventure Park NRH",
      "poi_type": "Entertainment",
      "poi_address": "6635 NE Loop 820, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Family-friendly indoor entertainment fun spot featuring slides, obstacle courses and a ropes course.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-723a-776c-b6b2-7f83e515d6c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-723a-776c-b6b2-7f83e515d6c5",
        "storage_key": "property/6767906449167730/01a03a1e-723a-776c-b6b2-7f83e515d6c5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://catapultadventurepark.com/north-richland-hills/",
      "poi_directions_map_url": "https://maps.google.com/?cid=77831467958932028&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "catapult-adventure-park-nrh",
      "poi_latitude": "32.8423317",
      "poi_longitude": "-97.2402293",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-769-9164",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnS_1JwB5ToYRPBIKyE6DFAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "ec_af5fc538136a8ca688816433",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "NRH Centre",
      "poi_type": "Health and Wellness",
      "poi_address": "6000 Hawk Ave, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Clean fitness and aquatic center offering classes, plus a facility for events and parties.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-6fb1-777c-b0c6-89a90ea5d73c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-6fb1-777c-b0c6-89a90ea5d73c",
        "storage_key": "property/6767906449167730/01a03a1e-6fb1-777c-b0c6-89a90ea5d73c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.nrhcentre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9283738023132317866&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nrh-centre",
      "poi_latitude": "32.8563452",
      "poi_longitude": "-97.1934886",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-427-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnXZ3RkR4ToYRqsiWcIt21oA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "ec_092f5effd1854dbdf6a85b74",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "North Richland Hills Library",
      "poi_type": "Education",
      "poi_address": "9015 Grand Ave, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Large library featuring books for children and adults, plus computers, DVDs and study rooms.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-7052-7706-a2cd-b9c87fae4599.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-7052-7706-a2cd-b9c87fae4599",
        "storage_key": "property/6767906449167730/01a03a1e-7052-7706-a2cd-b9c87fae4599.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://library.nrhtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13027143893085892144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-richland-hills-library",
      "poi_latitude": "32.8549921",
      "poi_longitude": "-97.1926532",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-427-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-a2e6-727f-98f5-e572d602906e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1e-a2e6-727f-98f5-e572d602906e",
        "storage_key": "property/6767906449167730/01a03a1e-a2e6-727f-98f5-e572d602906e.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJnXZ3RkR4ToYRMK5ImVm2ybQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "ec_306fdd65382b6f4622521f99",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "NYTEX Sports Centre",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8851 Ice House Dr, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Indoor complex offering ice hockey, including junior-level games, and public skating sessions.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-6fc8-744d-a585-05f406e7265f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-6fc8-744d-a585-05f406e7265f",
        "storage_key": "property/6767906449167730/01a03a1e-6fc8-744d-a585-05f406e7265f.webp",
        "width": 500,
        "height": 356
      },
      "poi_business_url": "https://www.nytexsports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7265013831071379795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nytex-sports-centre",
      "poi_latitude": "32.8597424",
      "poi_longitude": "-97.1965327",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-336-4423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNV3MVbt4ToYRUzFPcZaD0mQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "ec_1ecb46423117286e34d30ef8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "PEPPA PIG Theme Park Dallas-Fort Worth",
      "poi_type": "Entertainment",
      "poi_address": "8851 Blvd 26, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Play spaces and a water section, plus a playground, at a kids' theme park.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-713a-7147-a3d2-9ad43468564c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1c-713a-7147-a3d2-9ad43468564c",
        "storage_key": "property/6767906449167730/01a03a1c-713a-7147-a3d2-9ad43468564c.webp",
        "width": 1280,
        "height": 1010
      },
      "poi_business_url": "https://www.peppapigthemepark.com/dallas-ft-worth/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=1581821522146752263&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peppa-pig-theme-park-dallas-fort-worth",
      "poi_latitude": "32.8483405",
      "poi_longitude": "-97.1963702",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 469-947-3752",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsWqwFFp5ToYRB_efJUvC8xU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_816878b8eb0c676dae90e874",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "NRH2O Family Water Park",
      "poi_type": "Entertainment",
      "poi_address": "9001 Blvd 26, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Pools, a water playground & a lazy river are among the offerings at this water park.",
      "poi_long_description": "Pools, a water playground & a lazy river are among the offerings at this water park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-771d-74aa-a6d2-d4b540ff2b4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1c-771d-74aa-a6d2-d4b540ff2b4c",
        "storage_key": "property/6767906449167730/01a03a1c-771d-74aa-a6d2-d4b540ff2b4c.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "http://www.nrh2o.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1179881649457106072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nrh2o-family-water-park",
      "poi_latitude": "32.8500662",
      "poi_longitude": "-97.1945008",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-427-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUxJqg7h4ToYRmIzk4BvIXxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "ec_1944a23fa9901ed4e0e6ed6a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Malibu Jack's North Richland Hills",
      "poi_type": "Entertainment",
      "poi_address": "8651 Airport Fwy, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-760d-721d-a408-6a29bcef9994.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1c-760d-721d-a408-6a29bcef9994",
        "storage_key": "property/6767906449167730/01a03a1c-760d-721d-a408-6a29bcef9994.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://www.malibujacks.net/nrh/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=14537273623760176851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "malibu-jacks-north-richland-hills",
      "poi_latitude": "32.8372671",
      "poi_longitude": "-97.1997494",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-479-9410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAUrcIwB5ToYR04bhylbFvsk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "ec_232debde815891d84a57f95b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Ninja Kidz Action Park",
      "poi_type": "Entertainment",
      "poi_address": "8800 N Tarrant Pkwy Ste 200, North Richland Hills, TX 76182, USA",
      "poi_short_description": "Trampoline arena with wall-to-wall trampolines, plus a ninja course, zip line, and trapeze.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-945b-71b4-8ac3-f1b47b71bc33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1c-945b-71b4-8ac3-f1b47b71bc33",
        "storage_key": "property/6767906449167730/01a03a1c-945b-71b4-8ac3-f1b47b71bc33.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ninjakidzpark.com/locations/north-richland-hills",
      "poi_directions_map_url": "https://maps.google.com/?cid=5180700569244370032&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ninja-kidz-action-park",
      "poi_latitude": "32.9026338",
      "poi_longitude": "-97.1970439",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 817-646-5265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLVMNLL7XTYYRcIR5HbiL5Uc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "ec_120daf679c1dbc2ab2941d46",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Medical City North Hills",
      "poi_type": "Health and Wellness",
      "poi_address": "4401 Booth Calloway Rd, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-8085-70a7-a41f-0137d9dca1db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1c-8085-70a7-a41f-0137d9dca1db",
        "storage_key": "property/6767906449167730/01a03a1c-8085-70a7-a41f-0137d9dca1db.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.medicalcityhealthcare.com/locations/medical-city-north-hills-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=15705034484950082842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-city-north-hills",
      "poi_latitude": "32.8291892",
      "poi_longitude": "-97.2135735",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-255-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd9-741f-9779-6c8e29199d1e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd9-741f-9779-6c8e29199d1e",
        "storage_key": "property/6767906449167730/01a03a1c-bdd9-741f-9779-6c8e29199d1e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJV-eO_Px4ToYRGqW1vKd989k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_369a495218a1bfc0891de612",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "CareNow Urgent Care - North Hills",
      "poi_type": "Health and Wellness",
      "poi_address": "6401 NE Loop 820 Ste 200, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-7293-77e8-835b-25309f571aae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-7293-77e8-835b-25309f571aae",
        "storage_key": "property/6767906449167730/01a03a1e-7293-77e8-835b-25309f571aae.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.carenow.com/locations/dallas-fort-worth/north-hills?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=9056268153368588389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---north-hills",
      "poi_latitude": "32.8426996",
      "poi_longitude": "-97.2464456",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-893-1630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBWWnjyZ5ToYRZbA3QOdTrn0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_cdc6d44aa00700857860e388",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "6350 Davis Blvd, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-769c-77bd-b350-f7f0c0bc36f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-769c-77bd-b350-f7f0c0bc36f5",
        "storage_key": "property/6767906449167730/01a03a1e-769c-77bd-b350-f7f0c0bc36f5.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-6350+davis+blvd-north+richland+hills-tx-76180/id=6631",
      "poi_directions_map_url": "https://maps.google.com/?cid=3053960260987218859&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "32.8615604",
      "poi_longitude": "-97.2084099",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-498-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-a2ff-7372-b1c0-142783182bce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1e-a2ff-7372-b1c0-142783182bce",
        "storage_key": "property/6767906449167730/01a03a1e-a2ff-7372-b1c0-142783182bce.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfZP485p4ToYRq2tNQq3YYSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_51c881aa8edaf265801a7244",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "9101 N Tarrant Pkwy, North Richland Hills, TX 76182, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-73cc-7669-a1ef-6f78d2f1780a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-73cc-7669-a1ef-6f78d2f1780a",
        "storage_key": "property/6767906449167730/01a03a1e-73cc-7669-a1ef-6f78d2f1780a.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/3274-north-richland-hills-tx/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=18147303028348965562&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "32.9056874",
      "poi_longitude": "-97.1899567",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 817-605-8190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-a2ff-7372-b1c0-142783182bce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1e-a2ff-7372-b1c0-142783182bce",
        "storage_key": "property/6767906449167730/01a03a1e-a2ff-7372-b1c0-142783182bce.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0_FiG3vWTYYRulIcrPQr2Ps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_fff42a1d18f9aa7a7deb7b10",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Movement Theory Fitness Club",
      "poi_type": "Health and Wellness",
      "poi_address": "6350 Glenview Dr Unit 106, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-7769-769c-977a-928c796088b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-7769-769c-977a-928c796088b6",
        "storage_key": "property/6767906449167730/01a03a1e-7769-769c-977a-928c796088b6.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "http://movementtheoryfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15700016452328381639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "movement-theory-fitness-club",
      "poi_latitude": "32.8237809",
      "poi_longitude": "-97.2477049",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-520-6406",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC8_EroN5ToYRx1zS-Mep4dk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_bec3934a23822f6126af3b80",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Crunch Fitness - North Richland Hills",
      "poi_type": "Health and Wellness",
      "poi_address": "6601 NE Loop 820, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Gym with a variety of group fitness classes, plus a \"no judgments\" philosophy.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-7bf6-71b0-b092-2924a9d04fee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1c-7bf6-71b0-b092-2924a9d04fee",
        "storage_key": "property/6767906449167730/01a03a1c-7bf6-71b0-b092-2924a9d04fee.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.crunch.com/locations/north-richland-hills",
      "poi_directions_map_url": "https://maps.google.com/?cid=9414081646416445460&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crunch-fitness---north-richland-hills",
      "poi_latitude": "32.8421554",
      "poi_longitude": "-97.2412669",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 682-610-3051",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZQftaY15ToYRFEAtJWGJpYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_81a035605ef102e1077324cc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "CrossFit OTL",
      "poi_type": "Health and Wellness",
      "poi_address": "9155 Blvd 26 #270, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Functional-movement, group fitness programs offered at a friendly facility with experienced coaches.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-7579-75d8-a769-348cdd4f4b6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-7579-75d8-a769-348cdd4f4b6d",
        "storage_key": "property/6767906449167730/01a03a1e-7579-75d8-a769-348cdd4f4b6d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://crossfit-otl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9913341474191288720&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-otl",
      "poi_latitude": "32.8559405",
      "poi_longitude": "-97.18805",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-662-2788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ92qCYXd5ToYRkKlRMoxDk4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_e131c7f08d77ace0a870714c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Shine Pole & Aerial Fitness Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "8535 Airport Fwy #200, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-7689-761a-9436-c3f1db61381a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-7689-761a-9436-c3f1db61381a",
        "storage_key": "property/6767906449167730/01a03a1e-7689-761a-9436-c3f1db61381a.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.shinefitnessstudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14792253661584629221&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shine-pole--aerial-fitness-studio",
      "poi_latitude": "32.8358329",
      "poi_longitude": "-97.2014739",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-756-1313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8-Q-S1h_ToYR5R05HlWkSM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_26e3dc73b781dde4cdffb01f",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Cross Timbers Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7680 Douglas Ln, North Richland Hills, TX 76182, USA",
      "poi_short_description": "City park with picnic tables and a playground, plus ball fields, trails, and a public restroom.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-75b7-7052-b57a-304f8a4f3cea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-75b7-7052-b57a-304f8a4f3cea",
        "storage_key": "property/6767906449167730/01a03a1e-75b7-7052-b57a-304f8a4f3cea.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.nrhtx.com/Facilities/Facility/Details/12",
      "poi_directions_map_url": "https://maps.google.com/?cid=15955886341334589825&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cross-timbers-park",
      "poi_latitude": "32.887894",
      "poi_longitude": "-97.228875",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-427-6620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdca-7657-a256-1aa649f54ebd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdca-7657-a256-1aa649f54ebd",
        "storage_key": "property/6767906449167730/01a03a1c-bdca-7657-a256-1aa649f54ebd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9SNiR8nXTYYRgWHB6xaybt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_0418759b39be1f14bf1c6d62",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Green Valley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7701 Smithfield Rd, North Richland Hills, TX 76182, USA",
      "poi_short_description": "Community green area with soccer fields, a picnic pavilion, playground, BBQ grills & a fishing pond.",
      "poi_long_description": "Community green area with soccer fields, a picnic pavilion, playground, BBQ grills & a fishing pond.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-79b7-75f4-bb86-3682ea18c3bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-79b7-75f4-bb86-3682ea18c3bd",
        "storage_key": "property/6767906449167730/01a03a1e-79b7-75f4-bb86-3682ea18c3bd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.nrhtx.com/Facilities/Facility/Details/48",
      "poi_directions_map_url": "https://maps.google.com/?cid=12848985094651597510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "green-valley-park",
      "poi_latitude": "32.8875335",
      "poi_longitude": "-97.2117496",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-427-6620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdca-7657-a256-1aa649f54ebd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdca-7657-a256-1aa649f54ebd",
        "storage_key": "property/6767906449167730/01a03a1c-bdca-7657-a256-1aa649f54ebd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtcu7MjfWTYYRxlL_4t3DULI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_c0c04d47714cc88c210a46c3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Fossil Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6101 Onyx Dr S, Fort Worth, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-79bd-721b-ae17-0d76b53aef6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-79bd-721b-ae17-0d76b53aef6f",
        "storage_key": "property/6767906449167730/01a03a1e-79bd-721b-ae17-0d76b53aef6f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.nrhtx.com/Facilities/Facility/Details/19",
      "poi_directions_map_url": "https://maps.google.com/?cid=1880299471274250292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fossil-creek-park",
      "poi_latitude": "32.8158986",
      "poi_longitude": "-97.2540786",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdca-7657-a256-1aa649f54ebd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdca-7657-a256-1aa649f54ebd",
        "storage_key": "property/6767906449167730/01a03a1c-bdca-7657-a256-1aa649f54ebd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmfWQNM55ToYRNBCoKGgqGBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_54ae5b70c36dd0f2e5ef9ad6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Adventure World Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7451 Starnes Rd, North Richland Hills, TX 76182, USA",
      "poi_short_description": "Open green space with a community-built playground for kids, plus walking trails & picnic tables.",
      "poi_long_description": "Open green space with a community-built playground for kids, plus walking trails & picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-841b-76e9-9301-eef9e67d18c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1c-841b-76e9-9301-eef9e67d18c7",
        "storage_key": "property/6767906449167730/01a03a1c-841b-76e9-9301-eef9e67d18c7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nrhtx.com/Facilities/Facility/Details/10",
      "poi_directions_map_url": "https://maps.google.com/?cid=4653781666082864085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventure-world-playground",
      "poi_latitude": "32.8829808",
      "poi_longitude": "-97.2215997",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-427-6620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdca-7657-a256-1aa649f54ebd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdca-7657-a256-1aa649f54ebd",
        "storage_key": "property/6767906449167730/01a03a1c-bdca-7657-a256-1aa649f54ebd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN2Fqm8zXTYYR1TsYvcSNlUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_9d19a65cad91f441e278cbdf",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Northfield Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7804 Davis Blvd, Northfield Pk Trl, North Richland Hills, TX 76182, USA",
      "poi_short_description": "Park featuring basketball and baseball fields along with sand volleyball courts, tennis courts and a playground.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-7a65-70a9-92a7-56942ab7cc68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-7a65-70a9-92a7-56942ab7cc68",
        "storage_key": "property/6767906449167730/01a03a1e-7a65-70a9-92a7-56942ab7cc68.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nrhtx.com/Facilities/Facility/Details/24",
      "poi_directions_map_url": "https://maps.google.com/?cid=9836581513159326627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northfield-park",
      "poi_latitude": "32.8908062",
      "poi_longitude": "-97.1985596",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 817-427-6620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdca-7657-a256-1aa649f54ebd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdca-7657-a256-1aa649f54ebd",
        "storage_key": "property/6767906449167730/01a03a1c-bdca-7657-a256-1aa649f54ebd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL9doshXWTYYRozsJEMWOgog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_df71ffa2223d40651391485a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Walker's Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8403 Emerald Hills Way, North Richland Hills, TX 76180, USA",
      "poi_short_description": "City park featuring baseball and softball fields, a walking trail, and picnic areas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-7b38-760b-bcd6-687a410772bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-7b38-760b-bcd6-687a410772bd",
        "storage_key": "property/6767906449167730/01a03a1e-7b38-760b-bcd6-687a410772bd.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.nrhtx.com/Facilities/Facility/Details/27",
      "poi_directions_map_url": "https://maps.google.com/?cid=11469990340986163135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walkers-creek-park",
      "poi_latitude": "32.8503726",
      "poi_longitude": "-97.2011947",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-427-6620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdca-7657-a256-1aa649f54ebd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdca-7657-a256-1aa649f54ebd",
        "storage_key": "property/6767906449167730/01a03a1c-bdca-7657-a256-1aa649f54ebd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcXPeW5V4ToYRv0-ky3GXLZ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_0955046373ce2e11911263fc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Enclave at Hometown",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8601 Ice House Dr, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Down-to-earth apartments with a pool, a fitness center, and friendly staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-7a65-70a9-92a7-5b3253e41fd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-7a65-70a9-92a7-5b3253e41fd2",
        "storage_key": "property/6767906449167730/01a03a1e-7a65-70a9-92a7-5b3253e41fd2.webp",
        "width": 928,
        "height": 522
      },
      "poi_business_url": "https://www.enclaveathometown.com/?rccustomid=Mzg0NTE%3D-ws2u%2Fbt4ciQ%3D&utm_source=gmb&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=7063924845320127154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enclave-at-hometown",
      "poi_latitude": "32.860364",
      "poi_longitude": "-97.1992649",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 844-389-5489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKfA5yaJ4ToYRssJcdTgaCGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "real_estate_agency"
    },
    {
      "id": "ec_70b50d261f180e1712b853d4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Linda Spurlock Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6400 Glenview Dr, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Community park featuring a kids' playground, walking/jogging trail, open fields & a pond.",
      "poi_long_description": "Community park featuring a kids' playground, walking/jogging trail, open fields & a pond.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-7cbc-745d-a2dc-923318a0312e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-7cbc-745d-a2dc-923318a0312e",
        "storage_key": "property/6767906449167730/01a03a1e-7cbc-745d-a2dc-923318a0312e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nrhtx.com/Facilities/Facility/Details/23",
      "poi_directions_map_url": "https://maps.google.com/?cid=9382430612010663564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "linda-spurlock-park",
      "poi_latitude": "32.8212662",
      "poi_longitude": "-97.2459896",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-590-8049",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdca-7657-a256-1aa649f54ebd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdca-7657-a256-1aa649f54ebd",
        "storage_key": "property/6767906449167730/01a03a1c-bdca-7657-a256-1aa649f54ebd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN0ht1Mp5ToYRjH6lbu4WNYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0f0e78b3ecf9a65544174a95",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "North Richland Hills/Iron Horse Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-7fc5-772d-af78-ef70f57754c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-7fc5-772d-af78-ef70f57754c6",
        "storage_key": "property/6767906449167730/01a03a1e-7fc5-772d-af78-ef70f57754c6.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5631713715274185447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-richland-hillsiron-horse-station",
      "poi_latitude": "32.8447652",
      "poi_longitude": "-97.2494671",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-a2e9-7795-b326-7c07c6059dd5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1e-a2e9-7795-b326-7c07c6059dd5",
        "storage_key": "property/6767906449167730/01a03a1e-a2e9-7795-b326-7c07c6059dd5.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJjWX3dj54ToYR5_qcM8ndJ04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tram_stop"
    },
    {
      "id": "ec_ba20c6251900edebf84d412c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "North Richland Hills/Smithfield TEXRail Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "6420 Smithfield Rd, North Richland Hills, TX 76182, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-7df1-7448-ab21-7296ee21feba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-7df1-7448-ab21-7296ee21feba",
        "storage_key": "property/6767906449167730/01a03a1e-7df1-7448-ab21-7296ee21feba.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ridetrinitymetro.org/stations/north-richland-hills-smithfield-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17453827278972292890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-richland-hillssmithfield-texrail-station",
      "poi_latitude": "32.8640386",
      "poi_longitude": "-97.2116058",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQM5-j55ToYRGo8qlm9zOPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "ec_93a217220e93d4b849fbad04",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Trinity Lakes Train station",
      "poi_type": "Transportation & Transit",
      "poi_address": "7979 Trinity Blvd, Fort Worth, TX 76118, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-7f7a-722d-a587-7c1a18586274.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-7f7a-722d-a587-7c1a18586274",
        "storage_key": "property/6767906449167730/01a03a1e-7f7a-722d-a587-7c1a18586274.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8694575473327337763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-lakes-train-station",
      "poi_latitude": "32.7997663",
      "poi_longitude": "-97.2102321",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ72L5LAB5ToYRI_F_wFNWqXg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_c08b82a3f51cac290a1d61d0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Fort Worth Central",
      "poi_type": "Transportation & Transit",
      "poi_address": "1001 Jones St, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-804e-7228-8512-47ba7da53208.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-804e-7228-8512-47ba7da53208",
        "storage_key": "property/6767906449167730/01a03a1e-804e-7228-8512-47ba7da53208.webp",
        "width": 1280,
        "height": 820
      },
      "poi_business_url": "http://ridetrinitymetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16666534907176730361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-worth-central",
      "poi_latitude": "32.7526669",
      "poi_longitude": "-97.3264798",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda8-703f-a5e8-bfbd2df85453.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda8-703f-a5e8-bfbd2df85453",
        "storage_key": "property/6767906449167730/01a03a1c-bda8-703f-a5e8-bfbd2df85453.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbEKLz5xToYR-b7q6jFtS-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_040d4fc211f9601b92422451",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "T&P Station Wedding & Event Venue",
      "poi_type": "Entertainment",
      "poi_address": "221 W Lancaster Ave, Fort Worth, TX 76102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-8094-74b2-a045-8bd5351e30a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-8094-74b2-a045-8bd5351e30a4",
        "storage_key": "property/6767906449167730/01a03a1e-8094-74b2-a045-8bd5351e30a4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tandpstation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16643737918690415824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tp-station-wedding--event-venue",
      "poi_latitude": "32.7463554",
      "poi_longitude": "-97.3278593",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 52 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 469-246-0295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ZDOAQlxToYR0NQ9anRv-uY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_ded89eca83a4450c51a6e704",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Bell",
      "poi_type": "Transportation & Transit",
      "poi_address": "3232 Bell Flight Blvd, Hurst, TX 76053, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-877b-76cf-ae88-6a0ef34b769a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1c-877b-76cf-ae88-6a0ef34b769a",
        "storage_key": "property/6767906449167730/01a03a1c-877b-76cf-ae88-6a0ef34b769a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://trinityrailwayexpress.org/station/bell-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11367673502258708933&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bell",
      "poi_latitude": "32.8046324",
      "poi_longitude": "-97.1551139",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bda8-703f-a5e8-bfbd2df85453.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bda8-703f-a5e8-bfbd2df85453",
        "storage_key": "property/6767906449167730/01a03a1c-bda8-703f-a5e8-bfbd2df85453.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJmSKsN5V-ToYRxUHAYNIWwp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_75a07016b577d27ce7d12677",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-84f7-71b1-ab6c-b858dee9e39c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-84f7-71b1-ab6c-b858dee9e39c",
        "storage_key": "property/6767906449167730/01a03a1e-84f7-71b1-ab6c-b858dee9e39c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "15.0 mi",
      "poi_walking_minutes": "5 hours 31 mins",
      "poi_biking_minutes": "1 hour 35 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-a2e7-771f-8ba0-e01ac8f522e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1e-a2e7-771f-8ba0-e01ac8f522e7",
        "storage_key": "property/6767906449167730/01a03a1e-a2e7-771f-8ba0-e01ac8f522e7.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_268aadfdb4276ce92bcf8ba9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Grapevine/Main Street Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "801 S Main St, Grapevine, TX 76051, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-867f-7104-b10b-396ed0bdfcaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-867f-7104-b10b-396ed0bdfcaa",
        "storage_key": "property/6767906449167730/01a03a1e-867f-7104-b10b-396ed0bdfcaa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ridetrinitymetro.org/texrail/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18405502107178557258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grapevinemain-street-station",
      "poi_latitude": "32.9338028",
      "poi_longitude": "-97.0772663",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 22 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEz-M8e0rTIYRSt8UY6Z6bf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "ec_fa912a45e794d9e6b5b548c4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "North Richland Hills City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4301 City Point Dr, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-8665-71b1-a211-d0eadef30b7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-8665-71b1-a211-d0eadef30b7d",
        "storage_key": "property/6767906449167730/01a03a1e-8665-71b1-a211-d0eadef30b7d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.nrhtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17726973294756893019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-richland-hills-city-hall",
      "poi_latitude": "32.8269764",
      "poi_longitude": "-97.2177788",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-427-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-c0ec-75cc-a3b2-d9cc6c998fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-c0ec-75cc-a3b2-d9cc6c998fe3",
        "storage_key": "property/6767906449167730/01a03a1c-c0ec-75cc-a3b2-d9cc6c998fe3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg54ft1l4ToYRWxHSQErcAvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_3e73f39145a579ef35caaa9c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Texas Health Harris Methodist Hurst-Euless-Bedford",
      "poi_type": "Health and Wellness",
      "poi_address": "1600 Hospital Pkwy, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-8534-705e-acc1-724ab9ed4cd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-8534-705e-acc1-724ab9ed4cd5",
        "storage_key": "property/6767906449167730/01a03a1e-8534-705e-acc1-724ab9ed4cd5.webp",
        "width": 1279,
        "height": 719
      },
      "poi_business_url": "https://www.texashealth.org/locations/texas-health-heb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8046041147271700356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-harris-methodist-hurst-euless-bedford",
      "poi_latitude": "32.8349711",
      "poi_longitude": "-97.1244698",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-848-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd9-741f-9779-6c8e29199d1e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd9-741f-9779-6c8e29199d1e",
        "storage_key": "property/6767906449167730/01a03a1c-bdd9-741f-9779-6c8e29199d1e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJw-xkb7J_ToYRhF9OL8tHqW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_ade773e3814d7ab21ceb7350",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Texas Health Springwood Behavioral Health Hospital HEB",
      "poi_type": "Health and Wellness",
      "poi_address": "2717 Tibbets Dr, Bedford, TX 76022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-87c0-774d-b7ba-6e5585c9055f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-87c0-774d-b7ba-6e5585c9055f",
        "storage_key": "property/6767906449167730/01a03a1e-87c0-774d-b7ba-6e5585c9055f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texashealth.org/Locations/texas-health-heb/THBHHEB",
      "poi_directions_map_url": "https://maps.google.com/?cid=4438936182469010262&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-springwood-behavioral-health-hospital-heb",
      "poi_latitude": "32.8346054",
      "poi_longitude": "-97.122411",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 682-236-6023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjcYwh61_ToYRVqOxgPBEmj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_3781cfa25e2b8049bd3bbb14",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "HealthMarkets",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9151 Blvd 26, North Richland Hills, TX 76180, USA",
      "poi_short_description": "Insurance agency in the HealthMarkets chain.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-86cc-775e-9497-fda491ec07c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-86cc-775e-9497-fda491ec07c8",
        "storage_key": "property/6767906449167730/01a03a1e-86cc-775e-9497-fda491ec07c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.healthmarkets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11996808464048374606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "healthmarkets",
      "poi_latitude": "32.856863",
      "poi_longitude": "-97.1886475",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-827-9990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDZYCb7p4ToYRTsMAerw5faY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "insurance_agency"
    },
    {
      "id": "ec_e47f906fb1e9f8d33fb2b238",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Tyson Foods Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6350 Browning Ct, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-9b44-73db-865b-21b890706813.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-9b44-73db-865b-21b890706813",
        "storage_key": "property/6767906449167730/01a03a1e-9b44-73db-865b-21b890706813.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.tyson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9910794481494645795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tyson-foods-inc",
      "poi_latitude": "32.8516694",
      "poi_longitude": "-97.2447213",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-656-5507",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoTxfkBR4ToYRI9xjPxI3iok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_f0b10b6b22c379337dea4008",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Portfolio Recovery Associates, LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6341 Grapevine Hwy Ste 500, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-89de-738c-8f8d-cdb8eef756c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-89de-738c-8f8d-cdb8eef756c8",
        "storage_key": "property/6767906449167730/01a03a1e-89de-738c-8f8d-cdb8eef756c8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.portfoliorecovery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9490086638958384131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "portfolio-recovery-associates-llc",
      "poi_latitude": "32.8115116",
      "poi_longitude": "-97.2479014",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-772-1413",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjTRMFcZ5ToYRA5TLeoSPs4M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "ec_1286e60699cb4be63f23a2dd",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "Smurfit Kappa Bates",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6433 Davis Blvd, Fort Worth, TX 76182, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-9ea5-723d-aeb9-223eea16b613.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-9ea5-723d-aeb9-223eea16b613",
        "storage_key": "property/6767906449167730/01a03a1e-9ea5-723d-aeb9-223eea16b613.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.smurfitkappa.com/us/locations/united-states/smurfit-kappa-fort-worth",
      "poi_directions_map_url": "https://maps.google.com/?cid=9134647123448872888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smurfit-kappa-bates",
      "poi_latitude": "32.8650733",
      "poi_longitude": "-97.2091526",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-498-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNThwaZt4ToYRuL-2TSnJxH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_7c20f1be2c551f6dd7655467",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "poi_name": "XPO Logistics LTL",
      "poi_type": "Transportation & Transit",
      "poi_address": "9151 Blvd 26, North Richland Hills, TX 76180, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1e-8bc1-771b-bdcc-c0001ea02763.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a03a1e-8bc1-771b-bdcc-c0001ea02763",
        "storage_key": "property/6767906449167730/01a03a1e-8bc1-771b-bdcc-c0001ea02763.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://xpo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=757897951025129357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "xpo-logistics-ltl",
      "poi_latitude": "32.8568153",
      "poi_longitude": "-97.1898269",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a03a1c-bdd3-73fe-83e1-9c54819d9ffe",
        "storage_key": "property/6767906449167730/01a03a1c-bdd3-73fe-83e1-9c54819d9ffe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT4h0vbB4ToYRjWfZwiuYhAo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    }
  ],
  "office_hours": [
    {
      "id": "ec_0f169d538ef9a29d418936e8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d10267bf1ccd3b26fd7a79fd",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "ec_33f92ed6db04a31010e296bd",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_485c0ba3b18b9d698f0e8d45",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "ec_cd5e6f5e919e9070cd5e55b6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c13be9eaa755f3dabe4b7980",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_fed0913ed22319fe1677d745",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "rating": "5",
      "name": "Strawberry Cupcake",
      "text": "I recently moved in at the Cavalli and my entire leasing experience has been great. Alecka and Brandi were great from start to finish. Moving at 8 months pregnant was not easy, but these two ladies made it as simple as possible. This is a great area and complex. I have been loving my stay here so far. I plan to be here for the next 2- 3 years until I sm ready to buy a home.",
      "date": "2026-07-30",
      "title": "false"
    },
    {
      "id": "ec_3c0b3c98c002ecb87ddb493f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "rating": "5",
      "name": "Mia Dahler",
      "text": "Aleka was absolutely amazing throughout the entire process of helping me get my new apartment. She was so kind, patient, and helpful every step of the way. She took the time to answer all of my questions, kept me updated, and made what could have been a stressful experience feel so much easier. I truly appreciated how caring and understanding she was, and it was clear that she genuinely wanted to help. Thanks to Aleka, everything went smoothly, and I couldn’t be happier with my new home. I highly recommend working with her if you have the chance! 💕☺️",
      "date": "2026-07-02",
      "title": "false"
    },
    {
      "id": "ec_ed25937659d50d1dcd65c755",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "rating": "5",
      "name": "Lauren Bradshaw",
      "text": "Idk if this will be my new place of residency yet I'm hoping but only time will tell. I did want to give an amazing shout out to the property and staff as I toured today. Aleca was such a delight! She was personable and my tour was everything. The amenities are spectacular truly and if I do make this my place of residency I definitely plan on bragging about my experience as a resident. This property is 10 mins from my job versus the 45 min commute one way im making daily is a bonus. The property was clean and very presentable. She knew a resident that came in by name and addressed her as such. It truly was an experience! If you have time stop by. I do have one request, granted I'm not sure if its marketing purposes but I wish they had the videos online to show my sister and boyfriend but I guess they can just come tour with me but thats the only downfall.",
      "date": "2026-04-22",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "page_item_url": "luxury-apartments-stainless-steel-appliances-NRH",
      "search_query": "luxury apartments with stainless steel appliances North Richland Hills",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Stainless Steel Appliances",
      "h2_subtitle": "Discover upscale living in North Richland Hills. Enjoy luxury apartments that feature stainless steel appliances and modern amenities.",
      "page_copy": "At Aster, we understand the importance of both style and functionality in your living space. Our luxury apartments come complete with stainless steel appliances, ensuring that your kitchen remains as elegant as it is practical. Located in the heart of North Richland Hills, these modern homes are designed with tall ceilings and luxury wood plank flooring, adding a touch of sophistication to everyday living.\n\nNorth Richland Hills offers an ideal backdrop for our unique community. Whether you're keen on exploring local attractions or enjoying the comfort of your new home, Aster provides an unparalleled living experience. Our apartments cater to those who seek contemporary finishes and top-tier amenities, making them the perfect choice for anyone looking to elevate their lifestyle in Tarrant County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Stainless Steel Appliances",
      "seo_description": "Enjoy Aster's luxury apartments in North Richland Hills, complete with stainless steel appliances and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "page_item_url": "apartments-tall-ceilings-Tarrant-County",
      "search_query": "apartments with tall ceilings Tarrant County",
      "category": "Amenity",
      "h1_title": "Apartments with Tall Ceilings in Tarrant County",
      "h2_subtitle": "Experience elevated living in Tarrant County. Discover our apartments with tall ceilings and modern amenities at Aster.",
      "page_copy": "Imagine living in a spacious apartment where tall ceilings transform your space into a light and airy haven. At Aster, located in Tarrant County, our apartments offer just that. The enhanced vertical space allows for better light diffusion and an open, expansive feel, making everyday living feel luxurious.\n\nOur community not only boasts tall ceilings but is also equipped with top-quality finishes and amenities. With stainless steel appliances and luxury wood plank flooring, every detail has been thoughtfully curated to offer a premium living experience. Perfectly situated in North Richland Hills, Aster provides the ideal combination of comfort and style, setting a new standard for apartment living in the area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Tall Ceilings in Tarrant County",
      "seo_description": "Discover Aster's Tarrant County apartments with tall ceilings, featuring modern amenities that elevate your living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "page_item_url": "luxury-wood-plank-flooring-apartments-near-76180",
      "search_query": "luxury wood plank flooring apartments near 76180",
      "category": "Amenity",
      "h1_title": "Apartments with Luxury Wood Plank Flooring",
      "h2_subtitle": "Find stylish apartments near 76180. Experience the elegance of luxury wood plank flooring at Aster.",
      "page_copy": "Experience the beauty of luxury wood plank flooring in your apartment at Aster, just a stone's throw from the 76180 area. Our flooring not only adds sophistication and warmth to your living space but also offers durability and easy maintenance, making it perfect for modern living.\n\nLocated in the thriving community of North Richland Hills, Aster offers a range of amenities that complement the upscale feel of our apartments. With stainless steel appliances and tall ceilings accompanying the gorgeous flooring, residents enjoy a harmonious blend of style and functionality. Embrace a refined lifestyle with all the comforts and elegance you desire, right here in Tarrant County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Flooring Apartments Near 76180",
      "seo_description": "Discover Aster's apartments near 76180 with luxury wood plank flooring, providing elegance and style in every home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "page_item_url": "high-end-apartments-North-Richland-Hills-TX",
      "search_query": "high-end apartments North Richland Hills TX",
      "category": "Amenity",
      "h1_title": "High-End Apartments in North Richland Hills, TX",
      "h2_subtitle": "Explore high-end living in North Richland Hills, TX. Aster offers exquisite apartments with premium features and modern amenities.",
      "page_copy": "Discover the pinnacle of luxury at Aster, your destination for high-end apartments in North Richland Hills, TX. Our community redefines upscale living with expertly designed spaces featuring tall ceilings and stainless steel appliances. From the moment you step in, you're greeted by luxury wood plank flooring that adds an elegant touch to each room.\n\nLocated in a prime area of Tarrant County, Aster's high-end apartments offer both convenience and opulence. Whether you're enjoying the spacious interiors or exploring nearby attractions, Aster ensures a vibrant and fulfilling lifestyle. Choose Aster for a living experience that seamlessly blends modernity and sophistication in the heart of North Richland Hills.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "High-End Apartments in North Richland Hills, TX",
      "seo_description": "Experience high-end living at Aster in North Richland Hills, TX. Enjoy premium apartments with modern amenities and designer features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "page_item_url": "stylish-living-spaces-North-Richland-Hills",
      "search_query": "stylish living spaces North Richland Hills",
      "category": "Amenity",
      "h1_title": "Stylish Living Spaces in North Richland Hills",
      "h2_subtitle": "Discover stylish living spaces at Aster. Located in North Richland Hills, our apartments offer modern design and luxury amenities.",
      "page_copy": "Step into a world of style and comfort at Aster, where our living spaces embody the essence of modern design. Situated in North Richland Hills, these apartments feature tall ceilings and luxury wood plank flooring that create an elegant, open atmosphere perfectly suited for stylish living.\n\nAster's attention to detail extends beyond aesthetics. Each apartment is equipped with stainless steel appliances, making everyday tasks a breeze while maintaining a sleek, modern look. Positioned in the vibrant community of North Richland Hills, Aster provides the ideal setting for those seeking a harmonious blend of sophistication and functionality in their living environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stylish Living Spaces in North Richland Hills",
      "seo_description": "Find stylish living spaces at Aster, North Richland Hills. Enjoy modern design and luxury amenities tailored for a chic lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "page_item_url": "studio-apartments-north-richland-hills",
      "search_query": "studio apartments north richland hills",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in North Richland Hills",
      "h2_subtitle": "Explore Aster's studio apartments in North Richland Hills. These stylish spaces offer modern luxury and convenience.",
      "page_copy": "Welcome to Aster, where studio living in North Richland Hills is redefined with style and comfort. Each of our studio apartments is thoughtfully designed to maximize space without compromising on modern luxury. Featuring tall ceilings and luxury wood plank flooring, these studios create an inviting and airy atmosphere.\n\nOur studios come with top-of-the-line stainless steel appliances, ensuring your home is as functional as it is beautiful. Located in Tarrant County's vibrant North Richland Hills community, Aster offers not only a home but a lifestyle, with amenities that enhance everyday living and a neighborhood ripe with activity and convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in North Richland Hills",
      "seo_description": "Discover Aster's studio apartments in North Richland Hills with modern luxury and convenience. Stylish and functional living spaces await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-tarrant-county",
      "search_query": "one bedroom apartments tarrant county",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Tarrant County",
      "h2_subtitle": "Find your perfect one bedroom apartment at Aster. Located in Tarrant County, these spaces offer comfort and style.",
      "page_copy": "At Aster, our one bedroom apartments in Tarrant County are the epitome of stylish and functional living. Each apartment showcases tall ceilings and luxury wood plank flooring, instantly elevating the ambiance to ensure a comfortable lifestyle. Complemented by modern stainless steel appliances, these one bedroom spaces are both practical and chic.\n\nNestled in the heart of North Richland Hills, Aster provides residents with a luxurious retreat without sacrificing convenience. Whether you're enjoying the contemporary design of your apartment or exploring the amenities nearby, Aster offers a superb living experience specifically designed for those who appreciate the finer things in Tarrant County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Tarrant County",
      "seo_description": "Explore Aster's one bedroom apartments in Tarrant County, offering modern amenities and stylish comfort in North Richland Hills.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "page_item_url": "two-bedroom-aster-apartments-tx",
      "search_query": "two bedroom aster apartments tx",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Aster Apartments in TX",
      "h2_subtitle": "Discover spacious two bedroom apartments at Aster. Located in TX, these homes blend luxury and comfort perfectly.",
      "page_copy": "Welcome to Aster, where two bedroom apartments in TX offer a harmonious blend of luxury and comfort. Each apartment is thoughtfully designed with expansive living areas, tall ceilings, and luxury wood plank flooring that create a sophisticated yet inviting atmosphere. Our two bedroom units provide ample space for both relaxation and entertaining.\n\nEquipped with modern stainless steel appliances, these homes ensure functionality meets style. Situated in the vibrant North Richland Hills community of Tarrant County, Aster not only provides luxurious living spaces but also a lifestyle enriched with superb amenities and a convenient location. Experience comfortable living blended with contemporary flair at Aster.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Aster Apartments in TX",
      "seo_description": "Find two bedroom apartments at Aster in TX. Experience modern luxury and spacious living in North Richland Hills.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-76180",
      "search_query": "three bedroom apartments near 76180",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 76180",
      "h2_subtitle": "Discover spacious three bedroom apartments close to 76180. Aster offers modern living with luxury amenities.",
      "page_copy": "Discover the spaciousness and modern elegance of Aster's three bedroom apartments near the 76180 area. Our expansive floor plans feature tall ceilings and luxury wood plank flooring, delivering a refined living experience. These thoughtfully designed homes offer ample space and comfort, ideal for families or those seeking extra room.\n\nEach apartment is equipped with high-end stainless steel appliances, ensuring a seamless blend of functionality and style. Located in North Richland Hills within Tarrant County, these apartments provide a convenient lifestyle surrounded by excellent amenities. At Aster, enjoy a comfortable living environment without compromising on modern luxury and convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 76180",
      "seo_description": "Explore three bedroom apartments at Aster near 76180. Enjoy spacious living with luxury features in North Richland Hills.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "page_item_url": "apartments-near-tarrant-county-college-northeast-campus",
      "search_query": "apartments near tarrant county college northeast campus",
      "category": "School",
      "h1_title": "Apartments Near Tarrant County College Northeast",
      "h2_subtitle": "Discover modern apartments near Tarrant County College Northeast Campus. Aster offers convenient living with luxury amenities.",
      "page_copy": "Located conveniently near the Tarrant County College Northeast Campus, Aster offers modern apartments that cater to both students and professionals alike. Each apartment is designed with stylish touches like luxury wood plank flooring and tall ceilings, creating a spacious and inviting atmosphere. Our stainless steel appliances add a touch of modern convenience to your everyday living.\n\nBeyond the exceptional apartment features, Aster's location in North Richland Hills provides a perfect balance of accessibility and tranquility. With easy access to educational resources and a vibrant local community, residents can enjoy both an active and relaxing lifestyle. Discover the ideal living environment tailored for those studying or working near Tarrant County College Northeast.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tarrant County College Northeast",
      "seo_description": "Find convenient apartments near Tarrant County College Northeast at Aster. Enjoy modern amenities and comfortable living in North Richland Hills.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "page_item_url": "apartments-near-medical-city-north-hills-tx",
      "search_query": "apartments near Medical City North Hills TX",
      "category": "Hospital",
      "h1_title": "Apartments Near Medical City North Hills TX",
      "h2_subtitle": "Explore modern living options near Medical City North Hills TX. Aster offers luxurious features and a prime location.",
      "page_copy": "Aster Apartments provides a perfect haven for those seeking a home near Medical City North Hills in TX. Our modern apartments combine luxury and convenience with features like tall ceilings and luxury wood plank flooring. Enjoy a spacious living environment that caters to your lifestyle needs, complete with sleek stainless steel appliances.\n\nSituated in the vibrant community of North Richland Hills, Aster's location allows easy access to Medical City North Hills and other essential services. Residents can relish a serene living experience while being minutes away from important medical facilities. Discover an ideal blend of elegance and practicality at Aster, where living comfortably is always within reach.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Medical City North Hills TX",
      "seo_description": "Find Aster Apartments near Medical City North Hills, TX. Enjoy luxurious features and a prime location in North Richland Hills.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "page_item_url": "apartments-close-to-medical-city-alliance-nrh",
      "search_query": "apartments close to Medical City Alliance North Richland Hills",
      "category": "Hospital",
      "h1_title": "Apartments Close to Medical City Alliance",
      "h2_subtitle": "Find stylish apartments close to Medical City Alliance in North Richland Hills. Aster offers modern amenities and a convenient location.",
      "page_copy": "Aster Apartments in North Richland Hills are ideally located close to Medical City Alliance, offering a perfect blend of convenience and style for healthcare professionals and families alike. Our apartments feature luxury wood plank flooring and soaring ceilings that enhance the sense of space and elegance, creating a welcoming atmosphere.\n\nEquipped with modern stainless steel appliances, each apartment at Aster is designed to make daily life both convenient and comfortable. Situated in a prime location, you'll appreciate the quick access to Medical City Alliance, as well as the vibrant local amenities. Experience a community that supports your lifestyle needs, right here at Aster.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Medical City Alliance",
      "seo_description": "Explore Aster Apartments close to Medical City Alliance in North Richland Hills. Enjoy modern living and convenience at a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "page_item_url": "apartments-near-bear-creek-park-nrh",
      "search_query": "apartments near Bear Creek Park North Richland Hills",
      "category": "Park",
      "h1_title": "Apartments Near Bear Creek Park NRH",
      "h2_subtitle": "Live near Bear Creek Park in North Richland Hills. Aster offers beautiful apartments with modern amenities just minutes from outdoor recreation.",
      "page_copy": "Discover Aster Apartments, conveniently located near Bear Creek Park in North Richland Hills, offering residents easy access to lush greenery and trails for recreational activities. Each apartment is furnished with luxury wood plank flooring and tall ceilings, providing a spacious and modern living environment. Enjoy the practicality of stainless steel appliances that add a sleek touch to your kitchen.\n\nAster’s prime location not only provides natural beauty with Bear Creek Park nearby but also offers a vibrant community with everything you need for a comfortable lifestyle. Whether you enjoy strolls in the park or soaking in the serene atmosphere, Aster is the perfect place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bear Creek Park NRH",
      "seo_description": "Find Aster Apartments near Bear Creek Park in North Richland Hills. Enjoy modern amenities and relaxed living close to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "page_item_url": "aster-apartments-close-to-chisholm-park-tx",
      "search_query": "Aster apartments close to Chisholm Park TX",
      "category": "Park",
      "h1_title": "Aster Apartments Near Chisholm Park TX",
      "h2_subtitle": "Discover Aster Apartments, conveniently close to Chisholm Park, TX. Enjoy modern amenities and a great location.",
      "page_copy": "Aster Apartments offers a perfect home base near the scenic Chisholm Park in TX. Our apartments boast luxury wood plank flooring, tall ceilings, and stainless steel appliances, creating a modern living experience. Residents enjoy not only the comforts of stylish interiors but also the convenience of a prime location.\n\nBeing close to Chisholm Park means you can easily access outdoor activities and enjoy the tranquil setting of lush greenery. Aster provides a harmonious blend of nature and luxury, ensuring you always have a peaceful retreat after a busy day. Experience exceptional living at Aster Apartments, where comfort meets convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Aster Apartments Near Chisholm Park TX",
      "seo_description": "Live at Aster Apartments, close to Chisholm Park, TX. Enjoy modern living in a prime location with luxurious amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167730",
      "source": "generator",
      "page_item_url": "rental-homes-by-adventure-world-playground-76180",
      "search_query": "rental homes by Adventure World Playground 76180",
      "category": "Park",
      "h1_title": "Rental Homes by Adventure World Playground",
      "h2_subtitle": "Discover rental homes conveniently located near Adventure World Playground in the 76180 ZIP code. Aster offers a vibrant and welcoming community.",
      "page_copy": "Located in the heart of North Richland Hills, Aster Apartments provides rental homes just a short drive from Adventure World Playground in the 76180 area. Experience the convenience of living near a fantastic family-friendly recreational spot filled with outdoor excitement and play areas.\n\nOur rentals feature modern amenities, including stainless steel appliances and luxury wood plank flooring, designed to enhance your living experience. With tall ceilings that accentuate spaciousness, Aster delivers an inviting environment perfect for both relaxation and entertaining. Choose Aster Apartments as your next home and enjoy proximity to both nature and modern conveniences.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes by Adventure World Playground",
      "seo_description": "Find rental homes near Adventure World Playground 76180. Enjoy the best of North Richland Hills living at Aster.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik1SOUR3bXNsc0M3SHZ3a1h1ZUVCYkE9PSIsInZhbHVlIjoiSnQ2MDZmWWxiVEdkOW1XMVViRnlpUT09IiwibWFjIjoiMGI0NWE3MjRmZDcxMGY2MDEyYjRkZmY0Mjk4ZjdmYzI2ZmE3MWFmNzMxMjA3ZjRkNzEwZTlkNTE5YzJkYTVlNSJ9"
    }
  ],
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik1SOUR3bXNsc0M3SHZ3a1h1ZUVCYkE9PSIsInZhbHVlIjoiSnQ2MDZmWWxiVEdkOW1XMVViRnlpUT09IiwibWFjIjoiMGI0NWE3MjRmZDcxMGY2MDEyYjRkZmY0Mjk4ZjdmYzI2ZmE3MWFmNzMxMjA3ZjRkNzEwZTlkNTE5YzJkYTVlNSJ9",
  "custom_audioeye_site_id": "595677cc-f84c-4992-a52c-fd6f982b827a",
  "custom_audioeye_site_hash": "6e0a28f6d567298a83103d0f9de5bf3d"
};

export const generatedAt = '2026-09-11T19:09:14.038Z';
